export const tokens = {
  platform: {
    teams: {
      manager: {
        title: 'platform.teams.manager.title'
      },
      add_organization: {
        title: 'platform.teams.add_organization.title'
      },
      organization: {
        start: {
          title: 'platform.teams.organization.start.title',
          description: 'platform.teams.organization.start.description'
        },
        nameInput: 'platform.teams.organization.nameInput'
      },
      plan: 'platform.teams.plan'
    }
  },
  onboarding: {
    organization: {
      title: 'onboarding.organization.title',
      description: 'onboarding.organization.description'
    },
    organization_pricing: {
      features: {
        questions: 'onboarding.organization_pricing.features.questions',
        pages: 'onboarding.organization_pricing.features.pages',
        minutes: 'onboarding.organization_pricing.features.minutes',
        users: 'onboarding.organization_pricing.features.users',
        users_other: 'onboarding.organization_pricing.features.users_other',
        multi_provider: 'onboarding.organization_pricing.features.multi_provider',
        dedicated_support: 'onboarding.organization_pricing.features.dedicated_support',
        priority_queues: 'onboarding.organization_pricing.features.priority_queues',
        low_priority: 'onboarding.organization_pricing.features.low_priority',
        slack_support: 'onboarding.organization_pricing.features.slack_support',
        high_question_limit: 'onboarding.organization_pricing.features.high_question_limit',
        unlimited_pages: 'onboarding.organization_pricing.features.unlimited_pages',
        unlimited_minutes: 'onboarding.organization_pricing.features.unlimited_minutes',
        unlimited_users: 'onboarding.organization_pricing.features.unlimited_users',
        advanced_multi_provider: 'onboarding.organization_pricing.features.advanced_multi_provider',
        separate_tenant: 'onboarding.organization_pricing.features.separate_tenant',
        sso: 'onboarding.organization_pricing.features.sso',
        guaranteed_sla: 'onboarding.organization_pricing.features.guaranteed_sla',
        security_report: 'onboarding.organization_pricing.features.security_report',
        xlsx_import: 'onboarding.organization_pricing.features.xlsx_import',
        max_mb_docs: 'onboarding.organization_pricing.features.max_mb_docs',
        max_mb_spreadsheets: 'onboarding.organization_pricing.features.max_mb_spreadsheets',
        max_mb_translator: 'onboarding.organization_pricing.features.max_mb_translator'
      },
      tooltips: {
        questions: 'onboarding.organization_pricing.tooltips.questions',
        pages: 'onboarding.organization_pricing.tooltips.pages',
        minutes: 'onboarding.organization_pricing.tooltips.minutes',
        multi_provider: 'onboarding.organization_pricing.tooltips.multi_provider',
        low_priority: 'onboarding.organization_pricing.tooltips.low_priority',
        slack_support: 'onboarding.organization_pricing.tooltips.slack_support',
        sso: 'onboarding.organization_pricing.tooltips.sso',
        high_question_limit: 'onboarding.organization_pricing.tooltips.high_question_limit',
        max_mb_docs: 'onboarding.organization_pricing.tooltips.max_mb_docs',
        max_mb_spreadsheets: 'onboarding.organization_pricing.tooltips.max_mb_spreadsheets',
        max_mb_translator: 'onboarding.organization_pricing.tooltips.max_mb_translator'
      },
      plans: {
        description: {
          individual_users: 'onboarding.organization_pricing.plans.description.individual_users',
          growing_teams: 'onboarding.organization_pricing.plans.description.growing_teams',
          large_organizations: 'onboarding.organization_pricing.plans.description.large_organizations'
        }
      },
      upgrade_plan: 'onboarding.organization_pricing.upgrade_plan',
      choose_plan_for_organization: 'onboarding.organization_pricing.choose_plan_for_organization',
      current_plan_message: 'onboarding.organization_pricing.current_plan_message',
      congratulations_choose_plan: 'onboarding.organization_pricing.congratulations_choose_plan',
      continue_with_plan: 'onboarding.organization_pricing.continue_with_plan',
      subscribe_now: 'onboarding.organization_pricing.subscribe_now',
      contact_sales: 'onboarding.organization_pricing.contact_sales',
      month: 'onboarding.organization_pricing.month',
      custom: 'onboarding.organization_pricing.custom',
      most_popular: 'onboarding.organization_pricing.most_popular',
      contact_sales_modal: {
        upgrade_to_enterprise: 'onboarding.organization_pricing.contact_sales_modal.upgrade_to_enterprise',
        submit_request: 'onboarding.organization_pricing.contact_sales_modal.submit_request',
        my_email: 'onboarding.organization_pricing.contact_sales_modal.my_email',
        subject: 'onboarding.organization_pricing.contact_sales_modal.subject',
        describe_needs: 'onboarding.organization_pricing.contact_sales_modal.describe_needs',
        send_request: 'onboarding.organization_pricing.contact_sales_modal.send_request',
        additional_message: 'onboarding.organization_pricing.contact_sales_modal.additional_message',
        request_to_upgrade_placeholder: 'onboarding.organization_pricing.contact_sales_modal.request_to_upgrade_placeholder',
        request_submitted: 'onboarding.organization_pricing.contact_sales_modal.request_submitted',
        sales_team_contact: 'onboarding.organization_pricing.contact_sales_modal.sales_team_contact',
        whats_next: 'onboarding.organization_pricing.contact_sales_modal.whats_next',
        continue_with_community_plan: 'onboarding.organization_pricing.contact_sales_modal.continue_with_community_plan',
        continue_with_current_plan: 'onboarding.organization_pricing.contact_sales_modal.continue_with_current_plan'
      }
    }
  },
  dashboard: {
    title: 'dashboard.title',
    tab: {
      overview: 'dashboard.tab.overview',
      analytics: 'dashboard.tab.analytics'
    },
    metric: {
      questionsAnswered: 'dashboard.metric.questionsAnswered',
      metricPeriod: {
        description: 'dashboard.metric.metricPeriod.description'
      },
      files: 'dashboard.metric.files',
      invitedUsers: {
        title: 'dashboard.metric.invitedUsers.title',
        description: 'dashboard.metric.invitedUsers.description'
      },
      groups: {
        title: 'dashboard.metric.groups.title',
        description: 'dashboard.metric.groups.description'
      }
    },
    graph: {
      title: 'dashboard.graph.title',
      subtitle: 'dashboard.graph.subtitle',
      totalTooltip: 'dashboard.graph.totalTooltip',
      noInteractionData: 'dashboard.graph.noInteractionData'
    },
    chatHistoryTable: {
      questionColumn: 'dashboard.chatHistoryTable.questionColumn',
      numberOfMessagesColumn: 'dashboard.chatHistoryTable.numberOfMessagesColumn',
      dateColumn: 'dashboard.chatHistoryTable.dateColumn',
      askedBy: 'dashboard.chatHistoryTable.askedBy',
      title: 'dashboard.chatHistoryTable.title',
      description: 'dashboard.chatHistoryTable.description',
      questionFilter: {
        placeholder: 'dashboard.chatHistoryTable.questionFilter.placeholder'
      },
      modal: {
        title: 'dashboard.chatHistoryTable.modal.title'
      },
      noChatsFound: 'dashboard.chatHistoryTable.noChatsFound',
      loadingChatHistory: 'dashboard.chatHistoryTable.loadingChatHistory',
      deleteDialogTitle: 'dashboard.chatHistoryTable.deleteDialogTitle',
      deleteDialogDescription: 'dashboard.chatHistoryTable.deleteDialogDescription',
      feedbackFilter: {
        all: 'dashboard.chatHistoryTable.feedbackFilter.all',
        positive: 'dashboard.chatHistoryTable.feedbackFilter.positive',
        negative: 'dashboard.chatHistoryTable.feedbackFilter.negative',
        none: 'dashboard.chatHistoryTable.feedbackFilter.none',
        label: 'dashboard.chatHistoryTable.feedbackFilter.label'
      },
      feedback: {
        positive: {
          label: 'dashboard.chatHistoryTable.feedback.positive.label'
        },
        negative: {
          label: 'dashboard.chatHistoryTable.feedback.negative.label'
        }
      },
      metadataFilter: {
        title: 'dashboard.chatHistoryTable.metadataFilter.title',
        subtitle: 'dashboard.chatHistoryTable.metadataFilter.subtitle',
        addFilter: 'dashboard.chatHistoryTable.metadataFilter.addFilter',
        supportedTypes: 'dashboard.chatHistoryTable.metadataFilter.supportedTypes',
        typeText: 'dashboard.chatHistoryTable.metadataFilter.typeText',
        typeNumber: 'dashboard.chatHistoryTable.metadataFilter.typeNumber',
        typeBoolean: 'dashboard.chatHistoryTable.metadataFilter.typeBoolean',
        typeNull: 'dashboard.chatHistoryTable.metadataFilter.typeNull',
        key: 'dashboard.chatHistoryTable.metadataFilter.key',
        value: 'dashboard.chatHistoryTable.metadataFilter.value'
      }
    }
  },
  workstation: {
    title: 'workstation.title',
    subtitle: 'workstation.subtitle',
    welcome: 'workstation.welcome',
    welcomeSubtitle: 'workstation.welcomeSubtitle',
    prompt: {
      placeholder: 'workstation.prompt.placeholder'
    },
    newchat: 'workstation.newchat',
    sources: {
      title: 'workstation.sources.title',
      empty: 'workstation.sources.empty',
      search_results: 'workstation.sources.search_results',
      relevance: 'workstation.sources.relevance',
      previous: 'workstation.sources.previous',
      segmentTimestamps: 'workstation.sources.segmentTimestamps',
      videoStart: 'workstation.sources.videoStart',
      videoEnd: 'workstation.sources.videoEnd',
      next: 'workstation.sources.next',
      passage_in_documents: 'workstation.sources.passage_in_documents',
      passage_in_documents_plural: 'workstation.sources.passage_in_documents_plural',
      goToSource: 'workstation.sources.goToSource',
      errorLoadingVideo: 'workstation.sources.errorLoadingVideo',
      tryAgain: 'workstation.sources.tryAgain',
      show_message: 'workstation.sources.show_message'
    },
    reasoning: {
      title: 'workstation.reasoning.title',
      tools: {
        planner: 'workstation.reasoning.tools.planner',
        userFiles: 'workstation.reasoning.tools.userFiles',
        pageSearch: 'workstation.reasoning.tools.pageSearch',
        documentSearch: 'workstation.reasoning.tools.documentSearch',
        userFolders: 'workstation.reasoning.tools.userFolders',
        videoSearch: 'workstation.reasoning.tools.videoSearch',
        contentGenerator: 'workstation.reasoning.tools.contentGenerator',
        queryGeneration: 'workstation.reasoning.tools.queryGeneration',
        database: 'workstation.reasoning.tools.database',
        externalSearchTool: 'workstation.reasoning.tools.externalSearchTool',
        chatHistory: 'workstation.reasoning.tools.chatHistory',
        terminal: 'workstation.reasoning.tools.terminal',
        analytics: 'workstation.reasoning.tools.analytics',
        unifiedSearch: 'workstation.reasoning.tools.unifiedSearch'
      }
    },
    folders: {
      label: 'workstation.folders.label',
      empty: 'workstation.folders.empty',
      all_knowledge: 'workstation.folders.all_knowledge',
      searchFolders: 'workstation.folders.searchFolders',
      selectAllFolders: 'workstation.folders.selectAllFolders',
      deselectAllFolders: 'workstation.folders.deselectAllFolders',
      noResults: 'workstation.folders.noResults'
    },
    tools: {
      title: 'workstation.tools.title',
      externalSearch: 'workstation.tools.externalSearch',
      deepSearch: 'workstation.tools.deepSearch'
    },
    loadingSuggestions: 'workstation.loadingSuggestions',
    start_with_suggested_question: 'workstation.start_with_suggested_question',
    message: {
      file_search_results: 'workstation.message.file_search_results',
      web_search_results: 'workstation.message.web_search_results'
    },
    messages: {
      me: 'workstation.messages.me'
    },
    memory: {
      title: 'workstation.memory.title',
      subtitle: 'workstation.memory.subtitle'
    },
    history: {
      title: 'workstation.history.title',
      subtitle: 'workstation.history.subtitle'
    },
    report: {
      columns: {
        chat_id: 'workstation.report.columns.chat_id',
        user_message: 'workstation.report.columns.user_message',
        assistant_message: 'workstation.report.columns.assistant_message',
        created_at: 'workstation.report.columns.created_at',
        username: 'workstation.report.columns.username',
        user_email: 'workstation.report.columns.user_email'
      },
      download: 'workstation.report.download',
      downloading: 'workstation.report.downloading',
      truncatedContent: 'workstation.report.truncatedContent',
      toasts: {
        reportStartGeneration: {
          title: 'workstation.report.toasts.reportStartGeneration.title',
          description: 'workstation.report.toasts.reportStartGeneration.description'
        },
        reportSuccessfulGeneration: {
          title: 'workstation.report.toasts.reportSuccessfulGeneration.title',
          description: 'workstation.report.toasts.reportSuccessfulGeneration.description'
        },
        noDataReportGeneration: {
          title: 'workstation.report.toasts.noDataReportGeneration.title',
          description: 'workstation.report.toasts.noDataReportGeneration.description'
        },
        errorOnReportGeneration: {
          title: 'workstation.report.toasts.errorOnReportGeneration.title',
          description: 'workstation.report.toasts.errorOnReportGeneration.description'
        }
      }
    },
    feedbackModal: {
      suggestedReasons: {
        incorrect: 'workstation.feedbackModal.suggestedReasons.incorrect',
        outdated: 'workstation.feedbackModal.suggestedReasons.outdated',
        invented: 'workstation.feedbackModal.suggestedReasons.invented',
        irrelevant: 'workstation.feedbackModal.suggestedReasons.irrelevant',
        ignored: 'workstation.feedbackModal.suggestedReasons.ignored',
        generic: 'workstation.feedbackModal.suggestedReasons.generic',
        shallow: 'workstation.feedbackModal.suggestedReasons.shallow',
        confusing: 'workstation.feedbackModal.suggestedReasons.confusing',
        tooTechnical: 'workstation.feedbackModal.suggestedReasons.tooTechnical',
        redundant: 'workstation.feedbackModal.suggestedReasons.redundant',
        biased: 'workstation.feedbackModal.suggestedReasons.biased',
        title: 'workstation.feedbackModal.suggestedReasons.title'
      },
      input: {
        placeholder: 'workstation.feedbackModal.input.placeholder'
      },
      cancel: 'workstation.feedbackModal.cancel',
      sendFeedback: 'workstation.feedbackModal.sendFeedback',
      thankYouFeedback: 'workstation.feedbackModal.thankYouFeedback'
    }
  },
  tokens: {
    workstation: {
      reasoning: {
        process_steps: 'tokens.workstation.reasoning.process_steps',
        tools: {
          generic: 'tokens.workstation.reasoning.tools.generic'
        }
      }
    }
  },
  agent: {
    executions: {
      errors: {
        startExecution: 'agent.executions.errors.startExecution',
        continueExecution: 'agent.executions.errors.continueExecution',
        fetchReview: 'agent.executions.errors.fetchReview',
        fetchReviewDescription: 'agent.executions.errors.fetchReviewDescription',
        continueError: 'agent.executions.errors.continueError',
        unknownError: 'agent.executions.errors.unknownError'
      },
      review: {
        noPendingReviews: 'agent.executions.review.noPendingReviews',
        noPendingReviewsDescription: 'agent.executions.review.noPendingReviewsDescription',
        notFound: 'agent.executions.review.notFound',
        notFoundDescription: 'agent.executions.review.notFoundDescription',
        pending: 'agent.executions.review.pending'
      },
      selectAgent: 'agent.executions.selectAgent',
      loading: 'agent.executions.loading',
      noExecutionsFound: 'agent.executions.noExecutionsFound',
      columns: {
        executionDate: 'agent.executions.columns.executionDate',
        status: 'agent.executions.columns.status'
      },
      status: {
        completed: 'agent.executions.status.completed',
        failed: 'agent.executions.status.failed',
        skipped: 'agent.executions.status.skipped',
        notExecuted: 'agent.executions.status.notExecuted',
        review: 'agent.executions.status.review',
        canceled: 'agent.executions.status.canceled'
      },
      pagination: {
        pageOf: 'agent.executions.pagination.pageOf',
        firstPage: 'agent.executions.pagination.firstPage',
        previousPage: 'agent.executions.pagination.previousPage',
        nextPage: 'agent.executions.pagination.nextPage',
        lastPage: 'agent.executions.pagination.lastPage'
      },
      continueStarted: {
        title: 'agent.executions.continueStarted.title',
        description: 'agent.executions.continueStarted.description'
      },
      errorFetchingPendingReviews: 'agent.executions.errorFetchingPendingReviews',
      tryAgainLater: 'agent.executions.tryAgainLater'
    },
    access: {
      editAccess: 'agent.access.editAccess',
      allowedGroups: 'agent.access.allowedGroups',
      allowedUsers: 'agent.access.allowedUsers',
      selectGroups: 'agent.access.selectGroups',
      selectUsers: 'agent.access.selectUsers'
    },
    title: 'agent.title',
    subtitle: 'agent.subtitle',
    newAgent: 'agent.newAgent',
    notFound: 'agent.notFound',
    search: {
      agents: 'agent.search.agents'
    },
    label: {
      dataInput: 'agent.label.dataInput',
      processing: 'agent.label.processing',
      dataOutput: 'agent.label.dataOutput',
      howToUse: 'agent.label.howToUse',
      label: 'agent.label.label',
      format: 'agent.label.format',
      compareDocuments: 'agent.label.compareDocuments',
      folderSelection: 'agent.label.folderSelection',
      fileFilters: 'agent.label.fileFilters',
      addFilter: 'agent.label.addFilter',
      startsWith: 'agent.label.startsWith',
      endsWith: 'agent.label.endsWith',
      contains: 'agent.label.contains',
      extensions: 'agent.label.extensions',
      selectExtensions: 'agent.label.selectExtensions',
      filePreview: 'agent.label.filePreview',
      rules: 'agent.label.rules',
      newRule: 'agent.label.newRule',
      outputFormat: 'agent.label.outputFormat',
      generatePDF: 'agent.label.generatePDF',
      placeholderLabel: 'agent.label.placeholderLabel',
      selectFolder: 'agent.label.selectFolder',
      restApiConfiguration: 'agent.label.restApiConfiguration',
      url: 'agent.label.url',
      method: 'agent.label.method',
      timeout: 'agent.label.timeout',
      headers: 'agent.label.headers',
      headerKey: 'agent.label.headerKey',
      headerValue: 'agent.label.headerValue',
      emailConfiguration: 'agent.label.emailConfiguration',
      recipients: 'agent.label.recipients',
      subject: 'agent.label.subject',
      addRecipient: 'agent.label.addRecipient',
      removeRecipient: 'agent.label.removeRecipient'
    },
    editor: {
      ner: {
        title: 'agent.editor.ner.title',
        description: 'agent.editor.ner.description',
        addEntity: {
          label: 'agent.editor.ner.addEntity.label',
          namePlaceholder: 'agent.editor.ner.addEntity.namePlaceholder',
          descriptionPlaceholder: 'agent.editor.ner.addEntity.descriptionPlaceholder',
          examples: {
            label: 'agent.editor.ner.addEntity.examples.label',
            placeholder: 'agent.editor.ner.addEntity.examples.placeholder',
            addButton: 'agent.editor.ner.addEntity.examples.addButton'
          },
          button: 'agent.editor.ner.addEntity.button'
        },
        entities: {
          label: 'agent.editor.ner.entities.label',
          searchPlaceholder: 'agent.editor.ner.entities.searchPlaceholder',
          examplesButton: 'agent.editor.ner.entities.examplesButton',
          emptyState: 'agent.editor.ner.entities.emptyState',
          noResultsFound: 'agent.editor.ner.entities.noResultsFound',
          clearSearch: 'agent.editor.ner.entities.clearSearch'
        },
        editEntity: {
          namePlaceholder: 'agent.editor.ner.editEntity.namePlaceholder',
          descriptionPlaceholder: 'agent.editor.ner.editEntity.descriptionPlaceholder',
          examples: {
            label: 'agent.editor.ner.editEntity.examples.label',
            placeholder: 'agent.editor.ner.editEntity.examples.placeholder'
          },
          saveButton: 'agent.editor.ner.editEntity.saveButton',
          cancelButton: 'agent.editor.ner.editEntity.cancelButton'
        }
      },
      flowComponents: 'agent.editor.flowComponents',
      nodes: {
        input: 'agent.editor.nodes.input',
        processing: 'agent.editor.nodes.processing',
        output: 'agent.editor.nodes.output'
      },
      tabs: {
        editor: 'agent.editor.tabs.editor',
        executions: 'agent.editor.tabs.executions'
      },
      agentExecutions: 'agent.editor.agentExecutions',
      editConnection: 'agent.editor.editConnection',
      connection: {
        from: 'agent.editor.connection.from',
        to: 'agent.editor.connection.to'
      },
      recordAudio: {
        confirmDialog: {
          stopCurrentRecordingDescription: 'agent.editor.recordAudio.confirmDialog.stopCurrentRecordingDescription',
          stopCurrentRecordingTip: 'agent.editor.recordAudio.confirmDialog.stopCurrentRecordingTip',
          newRecording: 'agent.editor.recordAudio.confirmDialog.newRecording',
          previousRecordingWillBeLost: 'agent.editor.recordAudio.confirmDialog.previousRecordingWillBeLost',
          yes: 'agent.editor.recordAudio.confirmDialog.yes'
        },
        title: 'agent.editor.recordAudio.title',
        tooltip: 'agent.editor.recordAudio.tooltip',
        fileInfo: {
          size: 'agent.editor.recordAudio.fileInfo.size',
          duration: 'agent.editor.recordAudio.fileInfo.duration'
        },
        browserSupport: {
          apisNotSupported: 'agent.editor.recordAudio.browserSupport.apisNotSupported',
          mediaDevicesNotSupported: 'agent.editor.recordAudio.browserSupport.mediaDevicesNotSupported',
          featuresNotSupported: 'agent.editor.recordAudio.browserSupport.featuresNotSupported',
          microphoneNotSupported: 'agent.editor.recordAudio.browserSupport.microphoneNotSupported',
          screenShareNotSupported: 'agent.editor.recordAudio.browserSupport.screenShareNotSupported',
          mediaRecorderNotSupported: 'agent.editor.recordAudio.browserSupport.mediaRecorderNotSupported'
        },
        permissions: {
          permissionRequired: 'agent.editor.recordAudio.permissions.permissionRequired',
          allowMicrophoneAccess: 'agent.editor.recordAudio.permissions.allowMicrophoneAccess',
          selectArea: 'agent.editor.recordAudio.permissions.selectArea',
          selectScreenForAudio: 'agent.editor.recordAudio.permissions.selectScreenForAudio'
        },
        screenAudio: {
          screenAudioNotAvailable: 'agent.editor.recordAudio.screenAudio.screenAudioNotAvailable',
          shareAudioCheckbox: 'agent.editor.recordAudio.screenAudio.shareAudioCheckbox'
        },
        upload: {
          uploadError: 'agent.editor.recordAudio.upload.uploadError',
          failedToSendAudio: 'agent.editor.recordAudio.upload.failedToSendAudio',
          recordingSent: 'agent.editor.recordAudio.upload.recordingSent',
          audioFileSentSuccessfully: 'agent.editor.recordAudio.upload.audioFileSentSuccessfully'
        },
        recording: {
          recordingError: 'agent.editor.recordAudio.recording.recordingError',
          noAudioDataCaptured: 'agent.editor.recordAudio.recording.noAudioDataCaptured',
          recordingStarted: 'agent.editor.recordAudio.recording.recordingStarted',
          recordingMicrophoneAndScreen: 'agent.editor.recordAudio.recording.recordingMicrophoneAndScreen'
        },
        errors: {
          permissionDenied: 'agent.editor.recordAudio.errors.permissionDenied',
          allowMicrophoneAndScreenAccess: 'agent.editor.recordAudio.errors.allowMicrophoneAndScreenAccess',
          deviceNotFound: 'agent.editor.recordAudio.errors.deviceNotFound',
          microphoneOrScreenNotFound: 'agent.editor.recordAudio.errors.microphoneOrScreenNotFound',
          recordingCancelled: 'agent.editor.recordAudio.errors.recordingCancelled',
          selectionCancelledByUser: 'agent.editor.recordAudio.errors.selectionCancelledByUser',
          unknownErrorStartingRecording: 'agent.editor.recordAudio.errors.unknownErrorStartingRecording'
        },
        actions: {
          startRecording: 'agent.editor.recordAudio.actions.startRecording',
          stopRecording: 'agent.editor.recordAudio.actions.stopRecording'
        },
        browserNotSupported: 'agent.editor.recordAudio.browserNotSupported',
        sendToWorkstationTooltip: 'agent.editor.recordAudio.sendToWorkstationTooltip',
        sendToWorkstation: 'agent.editor.recordAudio.sendToWorkstation'
      },
      crawlerInput: {
        instructions: 'agent.editor.crawlerInput.instructions',
        instructionsTooltip: 'agent.editor.crawlerInput.instructionsTooltip',
        instructionPlaceholder: 'agent.editor.crawlerInput.instructionPlaceholder',
        urls: 'agent.editor.crawlerInput.urls',
        urlsTooltip: 'agent.editor.crawlerInput.urlsTooltip',
        maxPages: 'agent.editor.crawlerInput.maxPages',
        saveFiles: 'agent.editor.crawlerInput.saveFiles',
        saveFilesTooltip: 'agent.editor.crawlerInput.saveFilesTooltip',
        outputType: 'agent.editor.crawlerInput.outputType',
        outputTypeTooltipTitle: 'agent.editor.crawlerInput.outputTypeTooltipTitle',
        outputTypeDetailed: 'agent.editor.crawlerInput.outputTypeDetailed',
        outputTypeSummary: 'agent.editor.crawlerInput.outputTypeSummary',
        outputTypeDetailedDescription: 'agent.editor.crawlerInput.outputTypeDetailedDescription',
        outputTypeSummaryDescription: 'agent.editor.crawlerInput.outputTypeSummaryDescription'
      },
      availableNodes: {
        searchPlaceholder: {
          input: 'agent.editor.availableNodes.searchPlaceholder.input',
          processing: 'agent.editor.availableNodes.searchPlaceholder.processing',
          output: 'agent.editor.availableNodes.searchPlaceholder.output'
        },
        loading: 'agent.editor.availableNodes.loading',
        noResultsFound: 'agent.editor.availableNodes.noResultsFound'
      },
      inputFolder: {
        loadingFolders: 'agent.editor.inputFolder.loadingFolders',
        noFoldersFound: 'agent.editor.inputFolder.noFoldersFound',
        selectFolderFirst: 'agent.editor.inputFolder.selectFolderFirst',
        selectFolderToPreview: 'agent.editor.inputFolder.selectFolderToPreview',
        loading: 'agent.editor.inputFolder.loading',
        noFilesFound: 'agent.editor.inputFolder.noFilesFound'
      },
      textInput: {
        editContent: 'agent.editor.textInput.editContent',
        addContent: 'agent.editor.textInput.addContent',
        preview: 'agent.editor.textInput.preview',
        contentLabel: 'agent.editor.textInput.contentLabel',
        contentPlaceholder: 'agent.editor.textInput.contentPlaceholder'
      },
      consoleOutput: {
        checkConsoleMessage: 'agent.editor.consoleOutput.checkConsoleMessage'
      },
      llmGenerate: {
        agentCharacteristics: 'agent.editor.llmGenerate.agentCharacteristics',
        personality: {
          label: 'agent.editor.llmGenerate.personality.label',
          placeholder: 'agent.editor.llmGenerate.personality.placeholder'
        },
        role: {
          label: 'agent.editor.llmGenerate.role.label',
          placeholder: 'agent.editor.llmGenerate.role.placeholder'
        },
        instructions: {
          label: 'agent.editor.llmGenerate.instructions.label',
          placeholder: 'agent.editor.llmGenerate.instructions.placeholder',
          title: 'agent.editor.llmGenerate.instructions.title',
          addButton: 'agent.editor.llmGenerate.instructions.addButton'
        },
        toneLabel: 'agent.editor.llmGenerate.toneLabel',
        tonePlaceholder: 'agent.editor.llmGenerate.tonePlaceholder',
        languageLabel: 'agent.editor.llmGenerate.languageLabel',
        languagePlaceholder: 'agent.editor.llmGenerate.languagePlaceholder',
        abilitiesLabel: 'agent.editor.llmGenerate.abilitiesLabel',
        tone: {
          professional: 'agent.editor.llmGenerate.tone.professional',
          casual: 'agent.editor.llmGenerate.tone.casual',
          friendly: 'agent.editor.llmGenerate.tone.friendly',
          formal: 'agent.editor.llmGenerate.tone.formal'
        },
        language: {
          auto: 'agent.editor.llmGenerate.language.auto',
          english: 'agent.editor.llmGenerate.language.english',
          portuguese: 'agent.editor.llmGenerate.language.portuguese',
          spanish: 'agent.editor.llmGenerate.language.spanish',
          french: 'agent.editor.llmGenerate.language.french',
          italian: 'agent.editor.llmGenerate.language.italian'
        },
        abilities: {
          fileSearch: 'agent.editor.llmGenerate.abilities.fileSearch',
          webSearch: 'agent.editor.llmGenerate.abilities.webSearch',
          planning: 'agent.editor.llmGenerate.abilities.planning',
          imageAnalysis: 'agent.editor.llmGenerate.abilities.imageAnalysis'
        }
      },
      textTranslator: {
        requireReview: {
          label: 'agent.editor.textTranslator.requireReview.label',
          tooltip: 'agent.editor.textTranslator.requireReview.tooltip'
        },
        glossary: {
          updateButton: 'agent.editor.textTranslator.glossary.updateButton',
          addButton: 'agent.editor.textTranslator.glossary.addButton',
          cancelEditButton: 'agent.editor.textTranslator.glossary.cancelEditButton',
          label: 'agent.editor.textTranslator.glossary.label',
          termPlaceholder: 'agent.editor.textTranslator.glossary.termPlaceholder',
          translationPlaceholder: 'agent.editor.textTranslator.glossary.translationPlaceholder',
          tooltipTerm: 'agent.editor.textTranslator.glossary.tooltipTerm',
          tooltipTranslation: 'agent.editor.textTranslator.glossary.tooltipTranslation',
          searchPlaceholder: 'agent.editor.textTranslator.glossary.searchPlaceholder',
          noResultsFound: 'agent.editor.textTranslator.glossary.noResultsFound',
          noResultsHint: 'agent.editor.textTranslator.glossary.noResultsHint',
          emptyGlossary: 'agent.editor.textTranslator.glossary.emptyGlossary',
          emptyGlossaryHint: 'agent.editor.textTranslator.glossary.emptyGlossaryHint',
          editingItem: 'agent.editor.textTranslator.glossary.editingItem',
          editTitle: 'agent.editor.textTranslator.glossary.editTitle',
          addTitle: 'agent.editor.textTranslator.glossary.addTitle',
          termsLabel: 'agent.editor.textTranslator.glossary.termsLabel',
          removeTerm: 'agent.editor.textTranslator.glossary.removeTerm',
          closeButton: 'agent.editor.textTranslator.glossary.closeButton',
          saveButton: 'agent.editor.textTranslator.glossary.saveButton',
          loadingGlossaries: 'agent.editor.textTranslator.glossary.loadingGlossaries',
          editAction: 'agent.editor.textTranslator.glossary.editAction',
          duplicateAction: 'agent.editor.textTranslator.glossary.duplicateAction',
          deleteAction: 'agent.editor.textTranslator.glossary.deleteAction',
          deleteConfirmTitle: 'agent.editor.textTranslator.glossary.deleteConfirmTitle',
          deleteConfirmDescription: 'agent.editor.textTranslator.glossary.deleteConfirmDescription',
          cancelButton: 'agent.editor.textTranslator.glossary.cancelButton',
          confirmDeleteButton: 'agent.editor.textTranslator.glossary.confirmDeleteButton',
          viewTitle: 'agent.editor.textTranslator.glossary.viewTitle',
          loadingGlossary: 'agent.editor.textTranslator.glossary.loadingGlossary'
        },
        editInstructions: 'agent.editor.textTranslator.editInstructions',
        addInstructions: 'agent.editor.textTranslator.addInstructions',
        sourceLanguageLabel: 'agent.editor.textTranslator.sourceLanguageLabel',
        sourceLanguagePlaceholder: 'agent.editor.textTranslator.sourceLanguagePlaceholder',
        targetLanguageLabel: 'agent.editor.textTranslator.targetLanguageLabel',
        targetLanguagePlaceholder: 'agent.editor.textTranslator.targetLanguagePlaceholder',
        instructionsLabel: 'agent.editor.textTranslator.instructionsLabel',
        instructionsPlaceholder: 'agent.editor.textTranslator.instructionsPlaceholder',
        language: {
          english: 'agent.editor.textTranslator.language.english',
          portuguese: 'agent.editor.textTranslator.language.portuguese',
          spanish: 'agent.editor.textTranslator.language.spanish',
          french: 'agent.editor.textTranslator.language.french',
          italian: 'agent.editor.textTranslator.language.italian'
        },
        review: {
          title: 'agent.editor.textTranslator.review.title',
          success: {
            title: 'agent.editor.textTranslator.review.success.title',
            description: 'agent.editor.textTranslator.review.success.description'
          },
          error: {
            title: 'agent.editor.textTranslator.review.error.title',
            description: 'agent.editor.textTranslator.review.error.description'
          },
          reprocessTooltip: 'agent.editor.textTranslator.review.reprocessTooltip',
          rejectButton: 'agent.editor.textTranslator.review.rejectButton',
          approveButton: 'agent.editor.textTranslator.review.approveButton'
        },
        reprocess: {
          title: 'agent.editor.textTranslator.reprocess.title',
          placeholder: 'agent.editor.textTranslator.reprocess.placeholder',
          cancel: 'agent.editor.textTranslator.reprocess.cancel',
          button: 'agent.editor.textTranslator.reprocess.button'
        },
        documentViewer: {
          notSupported: 'agent.editor.textTranslator.documentViewer.notSupported',
          format: 'agent.editor.textTranslator.documentViewer.format',
          title: 'agent.editor.textTranslator.documentViewer.title'
        }
      },
      formatTemplate: {
        templateLabel: 'agent.editor.formatTemplate.templateLabel',
        tagLabel: 'agent.editor.formatTemplate.tagLabel',
        tagPlaceholder: 'agent.editor.formatTemplate.tagPlaceholder',
        tagTooltip: 'agent.editor.formatTemplate.tagTooltip',
        dragAndDropText: 'agent.editor.formatTemplate.dragAndDropText',
        fileSize: 'agent.editor.formatTemplate.fileSize',
        uploading: 'agent.editor.formatTemplate.uploading',
        sendTemplate: 'agent.editor.formatTemplate.sendTemplate',
        cancel: 'agent.editor.formatTemplate.cancel',
        replaceTemplate: 'agent.editor.formatTemplate.replaceTemplate',
        tooltip: {
          supportedFormats: 'agent.editor.formatTemplate.tooltip.supportedFormats',
          formats: 'agent.editor.formatTemplate.tooltip.formats',
          maxSize: 'agent.editor.formatTemplate.tooltip.maxSize'
        },
        success: {
          templateSent: 'agent.editor.formatTemplate.success.templateSent',
          templateReplaced: 'agent.editor.formatTemplate.success.templateReplaced'
        },
        errors: {
          fileTooLarge: {
            title: 'agent.editor.formatTemplate.errors.fileTooLarge.title',
            description: 'agent.editor.formatTemplate.errors.fileTooLarge.description'
          },
          unsupportedFormat: {
            title: 'agent.editor.formatTemplate.errors.unsupportedFormat.title',
            description: 'agent.editor.formatTemplate.errors.unsupportedFormat.description'
          },
          uploadError: {
            title: 'agent.editor.formatTemplate.errors.uploadError.title',
            description: 'agent.editor.formatTemplate.errors.uploadError.description'
          }
        }
      },
      splitDocument: {
        splitMode: {
          label: 'agent.editor.splitDocument.splitMode.label',
          placeholder: 'agent.editor.splitDocument.splitMode.placeholder',
          auto: 'agent.editor.splitDocument.splitMode.auto',
          ranges: 'agent.editor.splitDocument.splitMode.ranges',
          rangesDescription: 'agent.editor.splitDocument.splitMode.rangesDescription'
        },
        pages: {
          label: 'agent.editor.splitDocument.pages.label',
          tooltip: 'agent.editor.splitDocument.pages.tooltip'
        },
        auto: {
          title: 'agent.editor.splitDocument.auto.title',
          description: 'agent.editor.splitDocument.auto.description'
        }
      },
      extractContent: {
        textExtraction: 'agent.editor.extractContent.textExtraction',
        extractText: 'agent.editor.extractContent.extractText',
        imageExtraction: 'agent.editor.extractContent.imageExtraction',
        extractImages: 'agent.editor.extractContent.extractImages'
      },
      audioTranscription: {
        audioLanguage: {
          label: 'agent.editor.audioTranscription.audioLanguage.label',
          placeholder: 'agent.editor.audioTranscription.audioLanguage.placeholder',
          description: 'agent.editor.audioTranscription.audioLanguage.description'
        },
        language: {
          portuguese: 'agent.editor.audioTranscription.language.portuguese',
          english: 'agent.editor.audioTranscription.language.english',
          spanish: 'agent.editor.audioTranscription.language.spanish',
          french: 'agent.editor.audioTranscription.language.french',
          italian: 'agent.editor.audioTranscription.language.italian'
        }
      },
      generateReport: {
        instructions: {
          label: 'agent.editor.generateReport.instructions.label',
          placeholder: 'agent.editor.generateReport.instructions.placeholder',
          description: 'agent.editor.generateReport.instructions.description'
        },
        reportOptions: {
          label: 'agent.editor.generateReport.reportOptions.label',
          summary: 'agent.editor.generateReport.reportOptions.summary',
          importantDates: 'agent.editor.generateReport.reportOptions.importantDates',
          tasks: 'agent.editor.generateReport.reportOptions.tasks',
          conclusion: 'agent.editor.generateReport.reportOptions.conclusion',
          chartGeneration: 'agent.editor.generateReport.reportOptions.chartGeneration'
        }
      },
      fileInput: {
        fileLabel: 'agent.editor.fileInput.fileLabel',
        tooltip: {
          supportedFormats: 'agent.editor.fileInput.tooltip.supportedFormats',
          maxSize: 'agent.editor.fileInput.tooltip.maxSize'
        },
        fileSize: 'agent.editor.fileInput.fileSize',
        sendFile: 'agent.editor.fileInput.sendFile',
        uploading: 'agent.editor.fileInput.uploading',
        cancel: 'agent.editor.fileInput.cancel',
        replaceFile: 'agent.editor.fileInput.replaceFile',
        success: {
          fileSent: 'agent.editor.fileInput.success.fileSent'
        },
        errors: {
          unsupportedFormat: {
            title: 'agent.editor.fileInput.errors.unsupportedFormat.title',
            description: 'agent.editor.fileInput.errors.unsupportedFormat.description'
          },
          fileTooLarge: {
            title: 'agent.editor.fileInput.errors.fileTooLarge.title',
            description: 'agent.editor.fileInput.errors.fileTooLarge.description'
          },
          uploadError: {
            title: 'agent.editor.fileInput.errors.uploadError.title',
            description: 'agent.editor.fileInput.errors.uploadError.description'
          }
        }
      },
      changeNodeType: 'agent.editor.changeNodeType'
    },
    validation: {
      messages: {
        nerNodeNeedsEntities: 'agent.validation.messages.nerNodeNeedsEntities',
        crawlerInputInstructionsRequired: 'agent.validation.messages.crawlerInputInstructionsRequired',
        crawlerInputEmptyInstructions: 'agent.validation.messages.crawlerInputEmptyInstructions',
        crawlerInputInvalidUrls: 'agent.validation.messages.crawlerInputInvalidUrls',
        crawlerInputFolderRequired: 'agent.validation.messages.crawlerInputFolderRequired',
        crawlerInputMaxPagesRange: 'agent.validation.messages.crawlerInputMaxPagesRange',
        audioTranscriptionNodeNeedsLanguage: 'agent.validation.messages.audioTranscriptionNodeNeedsLanguage',
        agentNameRequired: 'agent.validation.messages.agentNameRequired',
        workflowNeedsNodes: 'agent.validation.messages.workflowNeedsNodes',
        workflowNeedsInputNodes: 'agent.validation.messages.workflowNeedsInputNodes',
        workflowNeedsOutputNodes: 'agent.validation.messages.workflowNeedsOutputNodes',
        nodeLabelRequired: 'agent.validation.messages.nodeLabelRequired',
        nodeNotConnected: 'agent.validation.messages.nodeNotConnected',
        nodeNeedsInput: 'agent.validation.messages.nodeNeedsInput',
        nodeNeedsOutput: 'agent.validation.messages.nodeNeedsOutput',
        workflowCannotHaveCycles: 'agent.validation.messages.workflowCannotHaveCycles',
        nodeNotConfigured: 'agent.validation.messages.nodeNotConfigured',
        textInputCannotBeEmpty: 'agent.validation.messages.textInputCannotBeEmpty',
        folderNodeNeedsFolder: 'agent.validation.messages.folderNodeNeedsFolder',
        translatorNodeNeedsConfig: 'agent.validation.messages.translatorNodeNeedsConfig',
        translatorNodeNeedsSourceLanguage: 'agent.validation.messages.translatorNodeNeedsSourceLanguage',
        translatorNodeNeedsTargetLanguage: 'agent.validation.messages.translatorNodeNeedsTargetLanguage',
        translatorNodeNeedsDifferentLanguages: 'agent.validation.messages.translatorNodeNeedsDifferentLanguages',
        llmNodeNeedsConfig: 'agent.validation.messages.llmNodeNeedsConfig',
        llmNodeNeedsInstructions: 'agent.validation.messages.llmNodeNeedsInstructions',
        formatTemplateNeedsTag: 'agent.validation.messages.formatTemplateNeedsTag',
        formatTemplateNeedsFile: 'agent.validation.messages.formatTemplateNeedsFile',
        splitDocumentNeedsRanges: 'agent.validation.messages.splitDocumentNeedsRanges',
        extractContentNeedsSelection: 'agent.validation.messages.extractContentNeedsSelection',
        restApiNodeNeedsUrl: 'agent.validation.messages.restApiNodeNeedsUrl',
        restApiNodeNeedsMethod: 'agent.validation.messages.restApiNodeNeedsMethod',
        restApiNodeNeedsValidTimeout: 'agent.validation.messages.restApiNodeNeedsValidTimeout',
        recordAudioNeedsFile: 'agent.validation.messages.recordAudioNeedsFile',
        fileInputNeedsFile: 'agent.validation.messages.fileInputNeedsFile',
        emailNodeNeedsRecipients: 'agent.validation.messages.emailNodeNeedsRecipients',
        emailNodeNeedsValidEmails: 'agent.validation.messages.emailNodeNeedsValidEmails'
      },
      hasValidationWarnings: 'agent.validation.hasValidationWarnings',
      workflowValid: 'agent.validation.workflowValid',
      warningsClickToSeeDetails: 'agent.validation.warningsClickToSeeDetails',
      warnings: 'agent.validation.warnings',
      nodeTypes: {
        textInput: 'agent.validation.nodeTypes.textInput',
        inputFolder: 'agent.validation.nodeTypes.inputFolder',
        outputFolder: 'agent.validation.nodeTypes.outputFolder',
        consoleOutput: 'agent.validation.nodeTypes.consoleOutput',
        textTranslator: 'agent.validation.nodeTypes.textTranslator',
        llmGenerate: 'agent.validation.nodeTypes.llmGenerate',
        documentComparison: 'agent.validation.nodeTypes.documentComparison',
        formatTemplate: 'agent.validation.nodeTypes.formatTemplate',
        extractContent: 'agent.validation.nodeTypes.extractContent',
        input: 'agent.validation.nodeTypes.input',
        processing: 'agent.validation.nodeTypes.processing',
        output: 'agent.validation.nodeTypes.output',
        inputFile: 'agent.validation.nodeTypes.inputFile',
        node: 'agent.validation.nodeTypes.node',
        restApiOutput: 'agent.validation.nodeTypes.restApiOutput',
        emailOutput: 'agent.validation.nodeTypes.emailOutput'
      }
    },
    nodes: {
      ner: {
        name: 'agent.nodes.ner.name',
        description: 'agent.nodes.ner.description'
      },
      crawlerInput: {
        name: 'agent.nodes.crawlerInput.name',
        description: 'agent.nodes.crawlerInput.description'
      },
      audioTranscription: {
        name: 'agent.nodes.audioTranscription.name',
        description: 'agent.nodes.audioTranscription.description'
      },
      generateReport: {
        name: 'agent.nodes.generateReport.name',
        description: 'agent.nodes.generateReport.description'
      },
      recordAudio: {
        name: 'agent.nodes.recordAudio.name',
        description: 'agent.nodes.recordAudio.description'
      },
      formatTemplate: {
        name: 'agent.nodes.formatTemplate.name',
        description: 'agent.nodes.formatTemplate.description'
      },
      extractContent: {
        name: 'agent.nodes.extractContent.name',
        description: 'agent.nodes.extractContent.description'
      },
      defaultInputNode: 'agent.nodes.defaultInputNode',
      selectInputNode: 'agent.nodes.selectInputNode',
      defaultProcessingNode: 'agent.nodes.defaultProcessingNode',
      selectProcessingNode: 'agent.nodes.selectProcessingNode',
      defaultOutputNode: 'agent.nodes.defaultOutputNode',
      selectOutputNode: 'agent.nodes.selectOutputNode',
      defaultNode: 'agent.nodes.defaultNode',
      label: {
        resultType: 'agent.nodes.label.resultType',
        attachment: 'agent.nodes.label.attachment',
        body: 'agent.nodes.label.body'
      },
      inputFolder: {
        name: 'agent.nodes.inputFolder.name',
        description: 'agent.nodes.inputFolder.description'
      },
      textInput: {
        name: 'agent.nodes.textInput.name',
        description: 'agent.nodes.textInput.description'
      },
      documentComparison: {
        name: 'agent.nodes.documentComparison.name',
        description: 'agent.nodes.documentComparison.description'
      },
      textTranslator: {
        name: 'agent.nodes.textTranslator.name',
        description: 'agent.nodes.textTranslator.description'
      },
      llmGenerate: {
        name: 'agent.nodes.llmGenerate.name',
        description: 'agent.nodes.llmGenerate.description'
      },
      outputFolder: {
        name: 'agent.nodes.outputFolder.name',
        description: 'agent.nodes.outputFolder.description'
      },
      consoleOutput: {
        name: 'agent.nodes.consoleOutput.name',
        description: 'agent.nodes.consoleOutput.description'
      },
      splitDocument: {
        name: 'agent.nodes.splitDocument.name',
        description: 'agent.nodes.splitDocument.description'
      },
      fileInput: {
        name: 'agent.nodes.fileInput.name',
        description: 'agent.nodes.fileInput.description'
      },
      restApiOutput: {
        name: 'agent.nodes.restApiOutput.name',
        description: 'agent.nodes.restApiOutput.description'
      },
      emailOutput: {
        name: 'agent.nodes.emailOutput.name',
        description: 'agent.nodes.emailOutput.description'
      }
    },
    scheduler: {
      selectDays: 'agent.scheduler.selectDays',
      weekDays: {
        sunday: 'agent.scheduler.weekDays.sunday',
        monday: 'agent.scheduler.weekDays.monday',
        tuesday: 'agent.scheduler.weekDays.tuesday',
        wednesday: 'agent.scheduler.weekDays.wednesday',
        thursday: 'agent.scheduler.weekDays.thursday',
        friday: 'agent.scheduler.weekDays.friday',
        saturday: 'agent.scheduler.weekDays.saturday'
      },
      scheduleExecution: 'agent.scheduler.scheduleExecution',
      title: 'agent.scheduler.title',
      dateAndTime: 'agent.scheduler.dateAndTime',
      selectDateAndTime: 'agent.scheduler.selectDateAndTime',
      recurring: 'agent.scheduler.recurring',
      repeatEvery: 'agent.scheduler.repeatEvery',
      select: 'agent.scheduler.select',
      intervals: {
        minute: 'agent.scheduler.intervals.minute',
        hour: 'agent.scheduler.intervals.hour',
        day: 'agent.scheduler.intervals.day',
        week: 'agent.scheduler.intervals.week',
        month: 'agent.scheduler.intervals.month',
        year: 'agent.scheduler.intervals.year'
      },
      daysOfWeek: 'agent.scheduler.daysOfWeek',
      ends: 'agent.scheduler.ends',
      endConditions: {
        never: 'agent.scheduler.endConditions.never',
        onDate: 'agent.scheduler.endConditions.onDate',
        afterOccurrences: 'agent.scheduler.endConditions.afterOccurrences'
      },
      endDate: 'agent.scheduler.endDate',
      selectDate: 'agent.scheduler.selectDate',
      numberOfOccurrences: 'agent.scheduler.numberOfOccurrences',
      errors: {
        loadSchedule: {
          title: 'agent.scheduler.errors.loadSchedule.title',
          description : 'agent.scheduler.errors.loadSchedule.description '
        },
        scheduleExecution: {
          title: 'agent.scheduler.errors.scheduleExecution.title',
          description: 'agent.scheduler.errors.scheduleExecution.description'
        }
      },
      success: {
        scheduleCreated: {
          title: 'agent.scheduler.success.scheduleCreated.title',
          description: 'agent.scheduler.success.scheduleCreated.description'
        }
      }
    },
    list: {
      errors: {
        loadAgents: {
          title: 'agent.list.errors.loadAgents.title',
          description: 'agent.list.errors.loadAgents.description'
        },
        deleteAgent: {
          title: 'agent.list.errors.deleteAgent.title',
          description: 'agent.list.errors.deleteAgent.description'
        },
        createAgent: {
          title: 'agent.list.errors.createAgent.title',
          description: 'agent.list.errors.createAgent.description'
        }
      },
      success: {
        agentActivated: {
          title: 'agent.list.success.agentActivated.title',
          description: 'agent.list.success.agentActivated.description'
        },
        agentDeactivated: {
          title: 'agent.list.success.agentDeactivated.title',
          description: 'agent.list.success.agentDeactivated.description'
        },
        agentScheduledImmediate : 'agent.list.success.agentScheduledImmediate ',
        agentScheduled: {
          title: 'agent.list.success.agentScheduled.title',
          description: 'agent.list.success.agentScheduled.description'
        }
      },
      status: {
        all: 'agent.list.status.all',
        active: 'agent.list.status.active',
        inactive: 'agent.list.status.inactive'
      },
      workingStatus: {
        working: 'agent.list.workingStatus.working',
        inactive: 'agent.list.workingStatus.inactive'
      },
      dialog: {
        activateAgent: {
          title: 'agent.list.dialog.activateAgent.title',
          description: 'agent.list.dialog.activateAgent.description',
          confirmText: 'agent.list.dialog.activateAgent.confirmText',
          chooseOption: 'agent.list.dialog.activateAgent.chooseOption',
          executeNow: 'agent.list.dialog.activateAgent.executeNow',
          schedule: 'agent.list.dialog.activateAgent.schedule'
        },
        deactivateAgent: {
          title: 'agent.list.dialog.deactivateAgent.title',
          description: 'agent.list.dialog.deactivateAgent.description',
          confirmText: 'agent.list.dialog.deactivateAgent.confirmText'
        }
      }
    },
    console: {
      title: 'agent.console.title',
      status: {
        label: 'agent.console.status.label',
        error: 'agent.console.status.error',
        completed: 'agent.console.status.completed',
        processing: 'agent.console.status.processing',
        connected: 'agent.console.status.connected',
        quotaExceeded: 'agent.console.status.quotaExceeded'
      },
      waitingForProcessing: 'agent.console.waitingForProcessing',
      totalMessages: 'agent.console.totalMessages',
      stopButton: 'agent.console.stopButton'
    },
    controls: {
      unsavedChanges: 'agent.controls.unsavedChanges',
      saveTooltip: 'agent.controls.saveTooltip',
      saving: 'agent.controls.saving',
      saved: 'agent.controls.saved',
      saveError: 'agent.controls.saveError',
      save: 'agent.controls.save',
      stopExecution: 'agent.controls.stopExecution',
      startExecution: 'agent.controls.startExecution'
    },
    dragDrop: {
      errorAddingNode: 'agent.dragDrop.errorAddingNode'
    },
    websocket: {
      startingConnection: 'agent.websocket.startingConnection',
      errorAgentIdNotSpecified: 'agent.websocket.errorAgentIdNotSpecified',
      errorProcessingMessage: 'agent.websocket.errorProcessingMessage',
      errorConnectingToServer: 'agent.websocket.errorConnectingToServer',
      connectionClosed: 'agent.websocket.connectionClosed',
      connectionInterrupted: 'agent.websocket.connectionInterrupted',
      executionCompletedSuccess: 'agent.websocket.executionCompletedSuccess',
      executionCompletedError: 'agent.websocket.executionCompletedError',
      quotaInsufficient: 'agent.websocket.quotaInsufficient',
      reviewRequired: 'agent.websocket.reviewRequired'
    },
    flow: {
      errorReloadingData: 'agent.flow.errorReloadingData',
      couldNotUpdateDataAfterStop: 'agent.flow.couldNotUpdateDataAfterStop',
      errorOnSave: 'agent.flow.errorOnSave',
      couldNotStartExecution: 'agent.flow.couldNotStartExecution',
      agentNamePlaceholder: 'agent.flow.agentNamePlaceholder'
    },
    workflow: {
      errorLoadingAgent: 'agent.workflow.errorLoadingAgent',
      pleaseTryAgain: 'agent.workflow.pleaseTryAgain'
    },
    loading: {
      loadingFlowFromServer: 'agent.loading.loadingFlowFromServer'
    }
  },
  ui: {
    toasts: {
      agent: {
        update_error: {
          title: 'ui.toasts.agent.update_error.title',
          description: 'ui.toasts.agent.update_error.description'
        }
      },
      organization: {
        switch_success: 'ui.toasts.organization.switch_success',
        invite_failed: 'ui.toasts.organization.invite_failed',
        invite_accepted: {
          title: 'ui.toasts.organization.invite_accepted.title',
          description: 'ui.toasts.organization.invite_accepted.description'
        },
        create_success: 'ui.toasts.organization.create_success',
        create_error: 'ui.toasts.organization.create_error',
        delete_failed: 'ui.toasts.organization.delete_failed'
      },
      team: {
        delete_active_error: 'ui.toasts.team.delete_active_error'
      },
      form: {
        submit_values: 'ui.toasts.form.submit_values'
      },
      auth: {
        sign_in_now: 'ui.toasts.auth.sign_in_now',
        login_error: {
          title: 'ui.toasts.auth.login_error.title'
        }
      },
      user: {
        deleted: 'ui.toasts.user.deleted'
      },
      file: {
        upload_success: 'ui.toasts.file.upload_success',
        uploaded_successfully: 'ui.toasts.file.uploaded_successfully',
        delete_success: 'ui.toasts.file.delete_success',
        imported: 'ui.toasts.file.imported',
        delete_error: {
          title: 'ui.toasts.file.delete_error.title',
          description: 'ui.toasts.file.delete_error.description'
        }
      },
      folder: {
        create_success: 'ui.toasts.folder.create_success',
        update_success: 'ui.toasts.folder.update_success',
        created: {
          description: 'ui.toasts.folder.created.description'
        },
        delete_success: 'ui.toasts.folder.delete_success',
        delete_error: {
          title: 'ui.toasts.folder.delete_error.title',
          description: 'ui.toasts.folder.delete_error.description'
        },
        create_error: {
          title: 'ui.toasts.folder.create_error.title',
          description: 'ui.toasts.folder.create_error.description'
        },
        update_error: {
          title: 'ui.toasts.folder.update_error.title',
          description: 'ui.toasts.folder.update_error.description'
        },
        delete_error_plural: {
          title: 'ui.toasts.folder.delete_error_plural.title',
          description: 'ui.toasts.folder.delete_error_plural.description'
        }
      },
      template: {
        delete_success: 'ui.toasts.template.delete_success'
      },
      translation: {
        delete_success: 'ui.toasts.translation.delete_success',
      },
      subscription: {
        failed: 'ui.toasts.subscription.failed'
      },
      sales: {
        contact: 'ui.toasts.sales.contact'
      },
      autorecharge: {
        enabled: 'ui.toasts.autorecharge.enabled',
        disabled: 'ui.toasts.autorecharge.disabled',
        status: 'ui.toasts.autorecharge.status',
        update_failed: 'ui.toasts.autorecharge.update_failed',
        update_success: {
          title: 'ui.toasts.autorecharge.update_success.title',
          description: 'ui.toasts.autorecharge.update_success.description'
        },
        update_settings_failed: 'ui.toasts.autorecharge.update_settings_failed'
      },
      error: {
        title: 'ui.toasts.error.title',
        forbidden: 'ui.toasts.error.forbidden',
        generic: 'ui.toasts.error.generic'
      },
      payment: {
        default_method_error: 'ui.toasts.payment.default_method_error'
      },
      amount: {
        invalid: 'ui.toasts.amount.invalid',
        enter_valid: 'ui.toasts.amount.enter_valid'
      },
      credit: {
        purchase_failed: 'ui.toasts.credit.purchase_failed'
      },
      group: {
        create_success: 'ui.toasts.group.create_success',
        update_success: 'ui.toasts.group.update_success',
        delete_success: 'ui.toasts.group.delete_success',
        create_error: {
          title: 'ui.toasts.group.create_error.title',
          description: 'ui.toasts.group.create_error.description'
        },
        update_error: {
          title: 'ui.toasts.group.update_error.title',
          description: 'ui.toasts.group.update_error.description'
        },
        delete_error: {
          title: 'ui.toasts.group.delete_error.title',
          description: 'ui.toasts.group.delete_error.description'
        }
      },
      glossary: {
        create_success: 'ui.toasts.glossary.create_success',
        update_success: 'ui.toasts.glossary.update_success',
        delete_success: 'ui.toasts.glossary.delete_success',
        duplicate_success: 'ui.toasts.glossary.duplicate_success',
      },
      member: {
        invite_success: 'ui.toasts.member.invite_success',
        removed_success: 'ui.toasts.member.removed_success',
        invite_error: {
          title: 'ui.toasts.member.invite_error.title',
          description: 'ui.toasts.member.invite_error.description'
        },
        remove_error: {
          title: 'ui.toasts.member.remove_error.title',
          description: 'ui.toasts.member.remove_error.description'
        }
      },
      request: {
        review: 'ui.toasts.request.review',
        failed: 'ui.toasts.request.failed',
        received: 'ui.toasts.request.received',
        send_success: {
          title: 'ui.toasts.request.send_success.title'
        }
      },
      task: {
        deleted: 'ui.toasts.task.deleted'
      },
      account: {
        created_successfully: {
          title: 'ui.toasts.account.created_successfully.title',
          description: 'ui.toasts.account.created_successfully.description'
        }
      },
      common: {
        try_again_later: 'ui.toasts.common.try_again_later'
      },
      generic_error: {
        title: 'ui.toasts.generic_error.title',
        default_message: 'ui.toasts.generic_error.default_message'
      }
    },
    textEditor: {
      toolbar: {
        undo: 'ui.textEditor.toolbar.undo',
        redo: 'ui.textEditor.toolbar.redo',
        fullscreen: 'ui.textEditor.toolbar.fullscreen',
        exitFullscreen: 'ui.textEditor.toolbar.exitFullscreen'
      },
      stats: {
        characters: 'ui.textEditor.stats.characters',
        minimum: 'ui.textEditor.stats.minimum'
      },
      readOnly: 'ui.textEditor.readOnly'
    },
    selectlanguage: 'ui.selectlanguage',
    common: {
      searchInput: 'ui.common.searchInput',
      pagination: {
        pageOf: 'ui.common.pagination.pageOf'
      },
      datetime: {
        days: 'ui.common.datetime.days',
        days_other: 'ui.common.datetime.days_other'
      },
      comingSoon: 'ui.common.comingSoon',
      selectDatePeriod: 'ui.common.selectDatePeriod',
      calendar: 'ui.common.calendar',
      periods: 'ui.common.periods',
      apply: 'ui.common.apply',
      warning: 'ui.common.warning',
      removeMemberWarning: 'ui.common.removeMemberWarning',
      removeMember: 'ui.common.removeMember',
      noResultsFound: 'ui.common.noResultsFound',
      noOptionsFound: 'ui.common.noOptionsFound',
      search: 'ui.common.search',
      page: 'ui.common.page',
      history: 'ui.common.history',
      consumption: 'ui.common.consumption',
      date: 'ui.common.date',
      quantity: 'ui.common.quantity',
      noRecordsFound: 'ui.common.noRecordsFound',
      sort: {
        asc: 'ui.common.sort.asc',
        desc: 'ui.common.sort.desc'
      },
      loading: 'ui.common.loading',
      enabled: 'ui.common.enabled',
      disabled: 'ui.common.disabled',
      of: 'ui.common.of',
      delete: 'ui.common.delete',
      view: 'ui.common.view',
      edit: 'ui.common.edit',
      selectConversation: 'ui.common.selectConversation',
      action: {
        connect: 'ui.common.action.connect',
        disconnect: 'ui.common.action.disconnect',
        improve: 'ui.common.action.improve'
      },
      openMenu: 'ui.common.openMenu'
    },
    feature: {
      underDevelopment: 'ui.feature.underDevelopment'
    },
    date: {
      predefinedPeriods: 'ui.date.predefinedPeriods',
      today: 'ui.date.today',
      yesterday: 'ui.date.yesterday',
      last7Days: 'ui.date.last7Days',
      last30Days: 'ui.date.last30Days',
      currentMonth: 'ui.date.currentMonth',
      lastMonth: 'ui.date.lastMonth',
      currentYear: 'ui.date.currentYear'
    },
    auth: {
      logout: 'ui.auth.logout',
      login: {
        subtitle: 'ui.auth.login.subtitle',
        description: 'ui.auth.login.description',
        agreement: {
          prefix: 'ui.auth.login.agreement.prefix',
          terms: 'ui.auth.login.agreement.terms',
          privacy: 'ui.auth.login.agreement.privacy',
          and: 'ui.auth.login.agreement.and'
        },
        forgot: 'ui.auth.login.forgot',
        password: 'ui.auth.login.password',
        no_account: 'ui.auth.login.no_account',
        signup: 'ui.auth.login.signup',
        or_continue: 'ui.auth.login.or_continue'
      },
      signup: {
        title: 'ui.auth.signup.title',
        confirmPassword: 'ui.auth.signup.confirmPassword',
        subtitle: 'ui.auth.signup.subtitle',
        already: 'ui.auth.signup.already',
        signin: 'ui.auth.signup.signin'
      },
      forgot: {
        title: 'ui.auth.forgot.title',
        email: 'ui.auth.forgot.email',
        enter_registered_email: 'ui.auth.forgot.enter_registered_email',
        send_password_link: 'ui.auth.forgot.send_password_link',
        submit: 'ui.auth.forgot.submit',
        signup: 'ui.auth.forgot.signup',
        signup_link: 'ui.auth.forgot.signup_link'
      }
    },
    input: {
      placeholder: {
        command: 'ui.input.placeholder.command'
      }
    },
    theme: {
      light: 'ui.theme.light',
      dark: 'ui.theme.dark',
      system: 'ui.theme.system'
    },
    confirmation: {
      DoYouConfirmThisAction: 'ui.confirmation.DoYouConfirmThisAction',
      areYouSure: 'ui.confirmation.areYouSure',
      cannotBeUndone: 'ui.confirmation.cannotBeUndone',
      nodeDeleteWarning: 'ui.confirmation.nodeDeleteWarning'
    },
    actions: {
      start: 'ui.actions.start',
      stop: 'ui.actions.stop',
      back: 'ui.actions.back',
      create: 'ui.actions.create',
      cancel: 'ui.actions.cancel',
      delete: 'ui.actions.delete',
      deleteAll: 'ui.actions.deleteAll',
      update: 'ui.actions.update',
      continue: 'ui.actions.continue',
      save: 'ui.actions.save',
      saving: 'ui.actions.saving',
      ask: 'ui.actions.ask',
      close: 'ui.actions.close',
      download: 'ui.actions.download'
    },
    table: {
      rowsSelected: 'ui.table.rowsSelected'
    },
    page: {
      notCreated: 'ui.page.notCreated',
      stayTuned: 'ui.page.stayTuned'
    },
    folderMultiSelect: {
      selectAll: 'ui.folderMultiSelect.selectAll',
      unselectAll: 'ui.folderMultiSelect.unselectAll',
      defaultPlaceholder: 'ui.folderMultiSelect.defaultPlaceholder'
    },
    moduleAccessDenied: {
      title: 'ui.moduleAccessDenied.title',
      description: 'ui.moduleAccessDenied.description',
      cta: 'ui.moduleAccessDenied.cta'
    }
  },
  aihub: {
    createAgent: {
      error: {
        title: 'aihub.createAgent.error.title',
        description: 'aihub.createAgent.error.description'
      }
    },
    createAssistant: {
      error: {
        title: 'aihub.createAssistant.error.title',
        description: 'aihub.createAssistant.error.description'
      }
    },
    gatewayTitle: 'aihub.gatewayTitle',
    gatewaySubtitle: 'aihub.gatewaySubtitle',
    gatewayNewFlow: 'aihub.gatewayNewFlow',
    gatewaySearchPlaceholder: 'aihub.gatewaySearchPlaceholder',
    gatewayItemsShowing: 'aihub.gatewayItemsShowing',
    gatewayNoResultsSearch: 'aihub.gatewayNoResultsSearch',
    gatewayNoResultsAgents: 'aihub.gatewayNoResultsAgents',
    gatewayNoResultsAssistants: 'aihub.gatewayNoResultsAssistants',
    gatewayNoResultsGeneral: 'aihub.gatewayNoResultsGeneral',
    gatewayLoadMore: 'aihub.gatewayLoadMore',
    gatewayLoading: 'aihub.gatewayLoading',
    gatewayDeleteConfirm: 'aihub.gatewayDeleteConfirm',
    gatewayDeleteAgent: 'aihub.gatewayDeleteAgent',
    gatewayDeleteAssistant: 'aihub.gatewayDeleteAssistant',
    gatewayDeleteAction: 'aihub.gatewayDeleteAction',
    gatewayCreateTitle: 'aihub.gatewayCreateTitle',
    gatewayCreateProcessFlow: 'aihub.gatewayCreateProcessFlow',
    gatewayCreateProcessFlowDesc: 'aihub.gatewayCreateProcessFlowDesc',
    gatewayCreateConversationalFlow: 'aihub.gatewayCreateConversationalFlow',
    gatewayCreateConversationalFlowDesc: 'aihub.gatewayCreateConversationalFlowDesc',
    gatewayFilterTitle: 'aihub.gatewayFilterTitle',
    gatewayFilterReset: 'aihub.gatewayFilterReset',
    gatewayFilterFlowType: 'aihub.gatewayFilterFlowType',
    gatewayFilterAll: 'aihub.gatewayFilterAll',
    gatewayFilterProcess: 'aihub.gatewayFilterProcess',
    gatewayFilterConversational: 'aihub.gatewayFilterConversational',
    gatewayFilterStatus: 'aihub.gatewayFilterStatus',
    gatewayFilterActive: 'aihub.gatewayFilterActive',
    gatewayFilterInactive: 'aihub.gatewayFilterInactive',
    gatewayFilterApply: 'aihub.gatewayFilterApply',
    gatewayFilterClear: 'aihub.gatewayFilterClear',
    gatewayFilterSoon: 'aihub.gatewayFilterSoon',
    assistantNotFound: 'aihub.assistantNotFound',
    assistantNotFoundDesc: 'aihub.assistantNotFoundDesc',
    assistantTabsConfigure: 'aihub.assistantTabsConfigure',
    assistantTabsPersonalize: 'aihub.assistantTabsPersonalize',
    assistantTabsVersions: 'aihub.assistantTabsVersions',
    assistantTabsIntegrate: 'aihub.assistantTabsIntegrate',
    assistantTabsPreview: 'aihub.assistantTabsPreview',
    assistantPreviewVersion: 'aihub.assistantPreviewVersion',
    assistantConfigTitle: 'aihub.assistantConfigTitle',
    assistantConfigNamePlaceholder: 'aihub.assistantConfigNamePlaceholder',
    assistantConfigDescription: 'aihub.assistantConfigDescription',
    assistantConfigDescriptionPlaceholder: 'aihub.assistantConfigDescriptionPlaceholder',
    assistantConfigKnowledgeTitle: 'aihub.assistantConfigKnowledgeTitle',
    assistantConfigKnowledgeEmpty: 'aihub.assistantConfigKnowledgeEmpty',
    assistantConfigKnowledgeAdd: 'aihub.assistantConfigKnowledgeAdd',
    assistantConfigKnowledgeInclude: 'aihub.assistantConfigKnowledgeInclude',
    assistantConfigKnowledgeSelectPlaceholder: 'aihub.assistantConfigKnowledgeSelectPlaceholder',
    assistantConfigKnowledgeLoading: 'aihub.assistantConfigKnowledgeLoading',
    assistantConfigKnowledgeInstructionsPlaceholder: 'aihub.assistantConfigKnowledgeInstructionsPlaceholder',
    assistantConfigKnowledgeRemove: 'aihub.assistantConfigKnowledgeRemove',
    assistantPersonalizeTitle: 'aihub.assistantPersonalizeTitle',
    assistantPersonalizeSubtitle: 'aihub.assistantPersonalizeSubtitle',
    assistantPersonalizeAvatar: 'aihub.assistantPersonalizeAvatar',
    assistantPersonalizeUpload: 'aihub.assistantPersonalizeUpload',
    assistantPersonalizeLogoMaxSize: 'aihub.assistantPersonalizeLogoMaxSize',
    assistantInterfaceTitle: 'aihub.assistantInterfaceTitle',
    assistantInterfaceHeaderBackground: 'aihub.assistantInterfaceHeaderBackground',
    assistantInterfaceHeaderText: 'aihub.assistantInterfaceHeaderText',
    assistantInterfaceChatBackground: 'aihub.assistantInterfaceChatBackground',
    assistantInterfaceChatBorder: 'aihub.assistantInterfaceChatBorder',
    assistantInterfaceUserBalloonBackground: 'aihub.assistantInterfaceUserBalloonBackground',
    assistantInterfaceUserBalloonText: 'aihub.assistantInterfaceUserBalloonText',
    assistantInterfaceAgentBalloonBackground: 'aihub.assistantInterfaceAgentBalloonBackground',
    assistantInterfaceAgentBalloonText: 'aihub.assistantInterfaceAgentBalloonText',
    assistantInterfaceInputTextColor: 'aihub.assistantInterfaceInputTextColor',
    assistantTypographyTitle: 'aihub.assistantTypographyTitle',
    assistantTypographyGreetingMessage: 'aihub.assistantTypographyGreetingMessage',
    assistantTypographyGreetingMessagePlaceholder: 'aihub.assistantTypographyGreetingMessagePlaceholder',
    assistantTypographySubtitleMessage: 'aihub.assistantTypographySubtitleMessage',
    assistantTypographySubtitleMessagePlaceholder: 'aihub.assistantTypographySubtitleMessagePlaceholder',
    assistantTypographyPlaceholderMessage: 'aihub.assistantTypographyPlaceholderMessage',
    assistantTypographyPlaceholderMessagePlaceholder: 'aihub.assistantTypographyPlaceholderMessagePlaceholder',
    assistantVersionsTitle: 'aihub.assistantVersionsTitle',
    assistantVersionsSubtitle: 'aihub.assistantVersionsSubtitle',
    assistantVersionsLoading: 'aihub.assistantVersionsLoading',
    assistantVersionsEmpty: 'aihub.assistantVersionsEmpty',
    assistantVersionsEmptyDescription: 'aihub.assistantVersionsEmptyDescription',
    assistantVersionsTableVersionName: 'aihub.assistantVersionsTableVersionName',
    assistantVersionsTableStatus: 'aihub.assistantVersionsTableStatus',
    assistantVersionsTableCreatedAt: 'aihub.assistantVersionsTableCreatedAt',
    assistantVersionsTableDeployedAt: 'aihub.assistantVersionsTableDeployedAt',
    assistantVersionsTableDeployed: 'aihub.assistantVersionsTableDeployed',
    assistantVersionsTableSaved: 'aihub.assistantVersionsTableSaved',
    assistantVersionsActionsEdit: 'aihub.assistantVersionsActionsEdit',
    assistantVersionsActionsDeploy: 'aihub.assistantVersionsActionsDeploy',
    assistantVersionsActionsDeploying: 'aihub.assistantVersionsActionsDeploying',
    assistantVersionsActionsDelete: 'aihub.assistantVersionsActionsDelete',
    assistantVersionsActionsOpenMenu: 'aihub.assistantVersionsActionsOpenMenu',
    assistantVersionsDialogDeployTitle: 'aihub.assistantVersionsDialogDeployTitle',
    assistantVersionsDialogDeployDescription: 'aihub.assistantVersionsDialogDeployDescription',
    assistantVersionsDialogDeployConfirm: 'aihub.assistantVersionsDialogDeployConfirm',
    assistantVersionsDialogDeleteTitle: 'aihub.assistantVersionsDialogDeleteTitle',
    assistantVersionsDialogDeleteDescription: 'aihub.assistantVersionsDialogDeleteDescription',
    confirmationCannotBeUndone: 'aihub.confirmationCannotBeUndone',
    assistantVersionsDialogDeleteConfirm: 'aihub.assistantVersionsDialogDeleteConfirm',
    assistantIntegrateTitle: 'aihub.assistantIntegrateTitle',
    assistantIntegrateSubtitle: 'aihub.assistantIntegrateSubtitle',
    assistantIntegrateWhatsappTitle: 'aihub.assistantIntegrateWhatsappTitle',
    assistantIntegrateWhatsappDescription: 'aihub.assistantIntegrateWhatsappDescription',
    assistantIntegrateWhatsappPhoneNumber: 'aihub.assistantIntegrateWhatsappPhoneNumber',
    assistantIntegrateWhatsappPhoneNumberPlaceholder: 'aihub.assistantIntegrateWhatsappPhoneNumberPlaceholder',
    assistantIntegrateWhatsappSearchCountry: 'aihub.assistantIntegrateWhatsappSearchCountry',
    assistantIntegrateWhatsappCountryNotFound: 'aihub.assistantIntegrateWhatsappCountryNotFound',
    assistantIntegrateWhatsappAdd: 'aihub.assistantIntegrateWhatsappAdd',
    assistantIntegrateWhatsappRegisteredNumbers: 'aihub.assistantIntegrateWhatsappRegisteredNumbers',
    assistantIntegrateWhatsappEmpty: 'aihub.assistantIntegrateWhatsappEmpty',
    assistantIntegrateWhatsappEmptyDescription: 'aihub.assistantIntegrateWhatsappEmptyDescription',
    assistantIntegrateWhatsappStatusValidated: 'aihub.assistantIntegrateWhatsappStatusValidated',
    assistantIntegrateWhatsappStatusPending: 'aihub.assistantIntegrateWhatsappStatusPending',
    assistantIntegrateWhatsappStatusUnknown: 'aihub.assistantIntegrateWhatsappStatusUnknown',
    assistantIntegrateIframeTitle: 'aihub.assistantIntegrateIframeTitle',
    assistantIntegrateIframeDescription: 'aihub.assistantIntegrateIframeDescription',
    assistantIntegrateIframeStep1: 'aihub.assistantIntegrateIframeStep1',
    assistantIntegrateIframeStep2: 'aihub.assistantIntegrateIframeStep2',
    assistantIntegrateIframeCopyError: 'aihub.assistantIntegrateIframeCopyError',
    assistantSaveVersionTitle: 'aihub.assistantSaveVersionTitle',
    assistantSaveVersionVersionName: 'aihub.assistantSaveVersionVersionName',
    assistantSaveVersionVersionNamePlaceholder: 'aihub.assistantSaveVersionVersionNamePlaceholder',
    assistantSaveVersionAutoDeploy: 'aihub.assistantSaveVersionAutoDeploy',
    assistantSaveVersionAutoDeployDescription: 'aihub.assistantSaveVersionAutoDeployDescription',
    assistantSaveVersionCancel: 'aihub.assistantSaveVersionCancel',
    assistantSaveVersionSave: 'aihub.assistantSaveVersionSave',
    assistantSaveVersionSaving: 'aihub.assistantSaveVersionSaving',
    assistantPreviewUnsavedChanges: 'aihub.assistantPreviewUnsavedChanges',
    assistantPreviewDiscardChanges: 'aihub.assistantPreviewDiscardChanges',
    assistantPreviewSaveVersion: 'aihub.assistantPreviewSaveVersion',
    assistantPreviewNewConversation: 'aihub.assistantPreviewNewConversation',
    assistantPreviewLoading: 'aihub.assistantPreviewLoading',
    assistantErrorCreateAgent: 'aihub.assistantErrorCreateAgent',
    assistantErrorCreateAgentDescription: 'aihub.assistantErrorCreateAgentDescription',
    assistantErrorCreateAssistant: 'aihub.assistantErrorCreateAssistant',
    assistantErrorCreateAssistantDescription: 'aihub.assistantErrorCreateAssistantDescription',
    validate: 'aihub.validate',
    whatsappPhoneAlreadyExists: 'aihub.whatsappPhoneAlreadyExists',
    whatsappValidationError: 'aihub.whatsappValidationError',
    whatsappValidationSuccess: 'aihub.whatsappValidationSuccess',
    whatsappValidationTitle: 'aihub.whatsappValidationTitle',
    whatsappValidationDescription: 'aihub.whatsappValidationDescription',
    whatsappValidatingPhone: 'aihub.whatsappValidatingPhone',
    whatsappGeneratingQRCode: 'aihub.whatsappGeneratingQRCode',
    whatsappScanQRCode: 'aihub.whatsappScanQRCode',
    whatsappWaitingForScan: 'aihub.whatsappWaitingForScan',
    whatsappConnecting: 'aihub.whatsappConnecting',
    whatsappAuthenticated: 'aihub.whatsappAuthenticated',
    whatsappAuthenticatedDescription: 'aihub.whatsappAuthenticatedDescription',
    whatsappAuthenticationFailed: 'aihub.whatsappAuthenticationFailed',
    whatsappValidationFailed: 'aihub.whatsappValidationFailed',
    whatsappVersionDeployed: 'aihub.whatsappVersionDeployed',
    whatsappVersionDeployError: 'aihub.whatsappVersionDeployError',
    tryAgain: 'aihub.tryAgain',
    error: 'aihub.error',
    success: 'aihub.success',
    whatsappRemovedSuccessfully: 'aihub.whatsappRemovedSuccessfully',
    whatsappRemovalError: 'aihub.whatsappRemovalError',
    whatsappPhoneAlreadyUsed: 'aihub.whatsappPhoneAlreadyUsed',
    whatsappRevalidationRequired: 'aihub.whatsappRevalidationRequired',
    gatewayFilterSelectAuthors: 'aihub.gatewayFilterSelectAuthors',
    gatewayFilterAuthorsPlaceholder: 'aihub.gatewayFilterAuthorsPlaceholder',
    gatewayFilterClearAuthors: 'aihub.gatewayFilterClearAuthors',
    gatewayFilterMy: 'aihub.gatewayFilterMy',
    gatewayFilterShared: 'aihub.gatewayFilterShared'
  },
  executionNodeData: {
    noDataAvailable: 'executionNodeData.noDataAvailable',
    input: 'executionNodeData.input',
    output: 'executionNodeData.output',
    noInputOutputData: 'executionNodeData.noInputOutputData'
  },
  files: {
    title: 'files.title',
    subtitle: 'files.subtitle',
    storage: {
      title: 'files.storage.title',
      used: 'files.storage.used',
      locked: 'files.storage.locked'
    },
    integration: {
      title: {
        googledrive: 'files.integration.title.googledrive',
        onedrive: 'files.integration.title.onedrive',
        sharepoint: 'files.integration.title.sharepoint'
      },
      status: {
        disconnected: 'files.integration.status.disconnected',
        connected: 'files.integration.status.connected'
      },
      action: {
        disconnected: 'files.integration.action.disconnected',
        connected: 'files.integration.action.connected',
        syncFolders: 'files.integration.action.syncFolders'
      },
      selectFolders: {
        header: 'files.integration.selectFolders.header',
        selectAllFolders: 'files.integration.selectFolders.selectAllFolders',
        noFolders: {
          googledrive: 'files.integration.selectFolders.noFolders.googledrive',
          onedrive: 'files.integration.selectFolders.noFolders.onedrive',
          sharepoint: 'files.integration.selectFolders.noFolders.sharepoint',
          sharepointSites: 'files.integration.selectFolders.noFolders.sharepointSites'
        }
      }
    },
    myFolders: 'files.myFolders',
    search: {
      placeholder: 'files.search.placeholder'
    },
    folderTable: {
      name: 'files.folderTable.name',
      items: 'files.folderTable.items',
      size: 'files.folderTable.size',
      createdAt: 'files.folderTable.createdAt',
      type: 'files.folderTable.type',
      private: 'files.folderTable.private',
      new: 'files.folderTable.new',
      editFolder: 'files.folderTable.editFolder',
      deleteFolder: 'files.folderTable.deleteFolder',
      access: {
        allowedGroups: 'files.folderTable.access.allowedGroups',
        allowedUsers: 'files.folderTable.access.allowedUsers',
        selectMembers: 'files.folderTable.access.selectMembers',
        selectGroups: 'files.folderTable.access.selectGroups',
        selectAllGroups: 'files.folderTable.access.selectAllGroups',
        selectAllMembers: 'files.folderTable.access.selectAllMembers'
      },
      createFolder: {
        folderName: 'files.folderTable.createFolder.folderName',
        title: 'files.folderTable.createFolder.title'
      },
      noResults: 'files.folderTable.noResults',
      searching: 'files.folderTable.searching'
    },
    fileTable: {
      filter: 'files.fileTable.filter',
      name: 'files.fileTable.name',
      size: 'files.fileTable.size',
      status: 'files.fileTable.status',
      uploadedAt: 'files.fileTable.uploadedAt',
      uploadCompleted: 'files.fileTable.uploadCompleted',
      uploadFile: 'files.fileTable.uploadFile',
      noResults: 'files.fileTable.noResults'
    }
  },
  integrations: {
    title: 'integrations.title',
    description: 'integrations.description',
    filter: {
      placeholder: 'integrations.filter.placeholder',
      all: 'integrations.filter.all',
      connected: 'integrations.filter.connected',
      notConnected: 'integrations.filter.notConnected'
    },
    card: {
      comingSoon: 'integrations.card.comingSoon',
      googleDrive: {
        title: 'integrations.card.googleDrive.title',
        description: 'integrations.card.googleDrive.description'
      },
      microsoft: {
        title: 'integrations.card.microsoft.title',
        description: 'integrations.card.microsoft.description'
      },
      whatsapp: {
        title: 'integrations.card.whatsapp.title',
        description: 'integrations.card.whatsapp.description'
      }
    }
  },
  settings: {
    title: 'settings.title',
    subtitle: 'settings.subtitle',
    usage: {
      title: 'settings.usage.title',
      subtitle: 'settings.usage.subtitle',
      subtitleHistory: 'settings.usage.subtitleHistory',
      questionsAsked: 'settings.usage.questionsAsked',
      processedPages: 'settings.usage.processedPages',
      minutesUsed: 'settings.usage.minutesUsed',
      organizationMembers: 'settings.usage.organizationMembers',
      upgradePlan: 'settings.usage.upgradePlan',
      usageLimitCredits: 'settings.usage.usageLimitCredits',
      viewCredits: 'settings.usage.viewCredits',
      maxMbUpload: 'settings.usage.maxMbUpload',
      filters: {
        questions: 'settings.usage.filters.questions',
        pages: 'settings.usage.filters.pages',
        minutes: 'settings.usage.filters.minutes',
        charges: 'settings.usage.filters.charges',
        agentExecutedNodes: 'settings.usage.filters.agentExecutedNodes',
        assistants: 'settings.usage.filters.assistants',
        mbDocs: 'settings.usage.filters.mbDocs',
        mbSpreadsheets: 'settings.usage.filters.mbSpreadsheets',
        mbTranslator: 'settings.usage.filters.mbTranslator'
      }
    },
    members: {
      title: 'settings.members.title',
      subtitle: 'settings.members.subtitle',
      invite: 'settings.members.invite',
      noMembersFound: 'settings.members.noMembersFound',
      noMembersSearchMatch: 'settings.members.noMembersSearchMatch',
      noMembersAddedMessage: 'settings.members.noMembersAddedMessage',
      inviteDescription: 'settings.members.inviteDescription',
      filter: 'settings.members.filter',
      fields: {
        name: 'settings.members.fields.name'
      },
      validation: {
        emailRequired: 'settings.members.validation.emailRequired',
        nameRequired: 'settings.members.validation.nameRequired'
      },
      you: 'settings.members.you'
    },
    groups: {
      title: 'settings.groups.title',
      subtitle: 'settings.groups.subtitle',
      createGroup: 'settings.groups.createGroup',
      filterGroup: 'settings.groups.filterGroup',
      name: 'settings.groups.name',
      membersLabel: 'settings.groups.membersLabel',
      membersLabel_other: 'settings.groups.membersLabel_other',
      permissionsLabel: 'settings.groups.permissionsLabel',
      permissionsLabel_other: 'settings.groups.permissionsLabel_other',
      selectPermissions: 'settings.groups.selectPermissions',
      delete: {
        confirmation: 'settings.groups.delete.confirmation',
        warning: 'settings.groups.delete.warning',
        title: 'settings.groups.delete.title'
      },
      add: {
        title: 'settings.groups.add.title',
        description: 'settings.groups.add.description'
      },
      noGroupsFound: 'settings.groups.noGroupsFound',
      noGroupsSearchMatch: 'settings.groups.noGroupsSearchMatch',
      noGroupsAddedMessage: 'settings.groups.noGroupsAddedMessage'
    },
    appearance: {
      preferences: {
        title: 'settings.appearance.preferences.title',
        subtitle: 'settings.appearance.preferences.subtitle'
      },
      logo: {
        title: 'settings.appearance.logo.title',
        subtitle: 'settings.appearance.logo.subtitle',
        maxSize: 'settings.appearance.logo.maxSize'
      },
      organization: {
        name: {
          title: 'settings.appearance.organization.name.title',
          subtitle: 'settings.appearance.organization.name.subtitle'
        }
      },
      font: 'settings.appearance.font',
      fontDescription: 'settings.appearance.fontDescription',
      theme: {
        title: 'settings.appearance.theme.title',
        light: 'settings.appearance.theme.light',
        dark: 'settings.appearance.theme.dark'
      },
      themeDescription: 'settings.appearance.themeDescription',
      save: 'settings.appearance.save'
    },
    billing: {
      title: 'settings.billing.title',
      subtitle: 'settings.billing.subtitle',
      subtitleHistory: 'settings.billing.subtitleHistory',
      creditBalance: 'settings.billing.creditBalance',
      addCredit: 'settings.billing.addCredit',
      managePlan: 'settings.billing.managePlan',
      plan_attention: {
        title: 'settings.billing.plan_attention.title',
        description: 'settings.billing.plan_attention.description',
        cta: 'settings.billing.plan_attention.cta'
      },
      autoRecharge: 'settings.billing.autoRecharge',
      autoRechargeDescription: 'settings.billing.autoRechargeDescription',
      modify: 'settings.billing.modify',
      ensureDefaultPaymentMethod: 'settings.billing.ensureDefaultPaymentMethod',
      availableCreditsTooltip: 'settings.billing.availableCreditsTooltip',
      credits: {
        add: 'settings.billing.credits.add',
        total_amount: 'settings.billing.credits.total_amount',
        common_options: 'settings.billing.credits.common_options',
        add_specific: 'settings.billing.credits.add_specific',
        monthly_limit: 'settings.billing.credits.monthly_limit',
        monthly_limit_tooltip: 'settings.billing.credits.monthly_limit_tooltip',
        auto_recharge_settings: 'settings.billing.credits.auto_recharge_settings',
        trigger_amount: 'settings.billing.credits.trigger_amount',
        trigger_amount_tooltip: 'settings.billing.credits.trigger_amount_tooltip',
        target_amount: 'settings.billing.credits.target_amount',
        target_amount_tooltip: 'settings.billing.credits.target_amount_tooltip',
        save_changes: 'settings.billing.credits.save_changes'
      },
      history: {
        paid: 'settings.billing.history.paid',
        pending: 'settings.billing.history.pending'
      },
      view: {
        receipt: 'settings.billing.view.receipt'
      }
    },
    apiKey: {
      title: 'settings.apiKey.title',
      subtitle: 'settings.apiKey.subtitle',
      createButton: 'settings.apiKey.createButton',
      searchMessage: 'settings.apiKey.searchMessage',
      noTokensFoundMessage: 'settings.apiKey.noTokensFoundMessage',
      createToastSuccess: 'settings.apiKey.createToastSuccess',
      createDialogSubtitle: 'settings.apiKey.createDialogSubtitle',
      baseDialog: {
        expiresAt: 'settings.apiKey.baseDialog.expiresAt',
        expiresAtOptions: {
          fifteenDays: 'settings.apiKey.baseDialog.expiresAtOptions.fifteenDays',
          thirtyDays: 'settings.apiKey.baseDialog.expiresAtOptions.thirtyDays',
          never: 'settings.apiKey.baseDialog.expiresAtOptions.never'
        },
        system: 'settings.apiKey.baseDialog.system',
        systemTokenTooltip: 'settings.apiKey.baseDialog.systemTokenTooltip',
        name: 'settings.apiKey.baseDialog.name',
        namePlaceholder: 'settings.apiKey.baseDialog.namePlaceholder',
        selectExpirationDate: 'settings.apiKey.baseDialog.selectExpirationDate',
        associatedGroups: 'settings.apiKey.baseDialog.associatedGroups',
        associatedGroupsTooltip: 'settings.apiKey.baseDialog.associatedGroupsTooltip',
        selectGroups: 'settings.apiKey.baseDialog.selectGroups',
        allowedFolders: 'settings.apiKey.baseDialog.allowedFolders'
      },
      copyNewTokenDialog: {
        title: 'settings.apiKey.copyNewTokenDialog.title',
        description: 'settings.apiKey.copyNewTokenDialog.description'
      },
      tableColumns: {
        name: 'settings.apiKey.tableColumns.name',
        apiKey: 'settings.apiKey.tableColumns.apiKey',
        createdAt: 'settings.apiKey.tableColumns.createdAt',
        permissions: 'settings.apiKey.tableColumns.permissions',
        noPermissionsTooltip: 'settings.apiKey.tableColumns.noPermissionsTooltip',
        activeStatusChip: 'settings.apiKey.tableColumns.activeStatusChip',
        expiredStatusChip: 'settings.apiKey.tableColumns.expiredStatusChip'
      },
      deleteToastSuccess: 'settings.apiKey.deleteToastSuccess'
    }
  },
  sidebar: {
    section: {
      general: 'sidebar.section.general',
      other: 'sidebar.section.other'
    },
    dashboard: 'sidebar.dashboard',
    workstation: 'sidebar.workstation',
    files: {
      title: 'sidebar.files.title',
      search: 'sidebar.files.search',
      myFolders: 'sidebar.files.myFolders'
    },
    integrations: 'sidebar.integrations',
    settings: 'sidebar.settings',
    members: 'sidebar.members',
    groups: 'sidebar.groups',
    appearance: 'sidebar.appearance',
    billing: 'sidebar.billing',
    usage: 'sidebar.usage',
    helpcenter: 'sidebar.helpcenter',
    statusPage: 'sidebar.statusPage',
    documentation: 'sidebar.documentation',
    translation: {
      title: 'sidebar.translation.title',
      fileManage: 'sidebar.translation.fileManage',
      glossary: 'sidebar.translation.glossary',
      translation: 'sidebar.translation.translation'
    }
  },
  plans: {
    community: 'plans.community',
    commercial: 'plans.commercial',
    enterprise: 'plans.enterprise'
  },
  landing: {
    knowledge_management: 'landing.knowledge_management',
    optimize_knowledge: 'landing.optimize_knowledge',
    knowledge_management_description: 'landing.knowledge_management_description',
    work_ai_agent: 'landing.work_ai_agent',
    custom_solutions: 'landing.custom_solutions',
    custom_solutions_description: 'landing.custom_solutions_description',
    integrations_description: 'landing.integrations_description',
    smart_agents_description: 'landing.smart_agents_description',
    resources: 'landing.resources',
    blog: 'landing.blog',
    login: 'landing.login',
    get_demo: 'landing.get_demo',
    description: 'landing.description',
    start_now: 'landing.start_now',
    automotive_chip: 'landing.automotive_chip',
    automotive_title: 'landing.automotive_title',
    machinery_equipment_chip: 'landing.machinery_equipment_chip',
    machinery_equipment_title: 'landing.machinery_equipment_title',
    media_communication_chip: 'landing.media_communication_chip',
    media_communication_title: 'landing.media_communication_title',
    aviation_chip: 'landing.aviation_chip',
    aviation_title: 'landing.aviation_title',
    get_in_touch: 'landing.get_in_touch',
    ai_leader: 'landing.ai_leader',
    ai_solutions_and_research: 'landing.ai_solutions_and_research',
    transformation_examples: 'landing.transformation_examples',
    tool_integrations: 'landing.tool_integrations',
    realtime_metrics_chip: 'landing.realtime_metrics_chip',
    realtime_metrics_title: 'landing.realtime_metrics_title',
    smart_agents: 'landing.smart_agents',
    tailored_solutions: 'landing.tailored_solutions',
    integrations_with_your_tools: 'landing.integrations_with_your_tools',
    who_trust_us: 'landing.who_trust_us',
    who_already_uses: 'landing.who_already_uses',
    simplify_ai: 'landing.simplify_ai',
    in_enterprise: 'landing.in_enterprise',
    full_platform: 'landing.full_platform',
    prompt_library: 'landing.prompt_library',
    reuse_prompts: 'landing.reuse_prompts',
    smart_search: 'landing.smart_search',
    find_info_ai: 'landing.find_info_ai',
    business_chat: 'landing.business_chat',
    natural_chat_interface: 'landing.natural_chat_interface',
    autonomous_agents: 'landing.autonomous_agents',
    create_no_code_agents: 'landing.create_no_code_agents',
    enterprise_ai_platform: 'landing.enterprise_ai_platform',
    full_architecture: 'landing.full_architecture',
    genai_foundation: 'landing.genai_foundation',
    multi_llm: 'landing.multi_llm',
    multi_llm_access: 'landing.multi_llm_access',
    rag_engine: 'landing.rag_engine',
    rag_description: 'landing.rag_description',
    memory: 'landing.memory',
    dynamic_learning: 'landing.dynamic_learning',
    intelligence_layer: 'landing.intelligence_layer',
    knowledge_graph: 'landing.knowledge_graph',
    knowledge_mapping: 'landing.knowledge_mapping',
    hybrid_search: 'landing.hybrid_search',
    hybrid_search_description: 'landing.hybrid_search_description',
    self_learning: 'landing.self_learning',
    self_learning_description: 'landing.self_learning_description',
    security_governance: 'landing.security_governance',
    real_time_permissions: 'landing.real_time_permissions',
    access_control: 'landing.access_control',
    content_policies: 'landing.content_policies',
    content_filtering: 'landing.content_filtering',
    continuous_audit: 'landing.continuous_audit',
    audit_monitoring: 'landing.audit_monitoring',
    full_ecosystem: 'landing.full_ecosystem',
    connect_tools: 'landing.connect_tools',
    data_sources: 'landing.data_sources',
    connect_all_tools: 'landing.connect_all_tools',
    engineering: 'landing.engineering',
    collaboration: 'landing.collaboration',
    documents: 'landing.documents',
    businesses: 'landing.businesses',
    infrastructure: 'landing.infrastructure',
    start_ai_today: 'landing.start_ai_today',
    transform_with_ai: 'landing.transform_with_ai',
    security_and_governance: 'landing.security_and_governance',
    how_we_protect_data: 'landing.how_we_protect_data',
    data_protection: 'landing.data_protection',
    compliance_check: 'landing.compliance_check',
    compliance_answer: 'landing.compliance_answer',
    data_access: 'landing.data_access',
    data_access_answer: 'landing.data_access_answer',
    hero_title: 'landing.hero_title',
    hero_subtitle: 'landing.hero_subtitle',
    contact_us_cta: 'landing.contact_us_cta',
    contact_us_text: 'landing.contact_us_text',
    find_us: 'landing.find_us',
    copyright: 'landing.copyright',
    terms: 'landing.terms',
    privacy: 'landing.privacy',
    enterprise_cta: 'landing.enterprise_cta',
    contact_button: 'landing.contact_button',
    community_text: 'landing.community_text',
    community_title: 'landing.community_title',
    slack_community_description: 'landing.slack_community_description',
    support_title: 'landing.support_title',
    support_description: 'landing.support_description',
    get_started_cta: 'landing.get_started_cta',
    explore_prompts: 'landing.explore_prompts',
    documentation_title: 'landing.documentation_title',
    documentation_description: 'landing.documentation_description',
    community_description: 'landing.community_description',
    latest_posts_title: 'landing.latest_posts_title',
    latest_posts_description: 'landing.latest_posts_description',
    recent_updates_title: 'landing.recent_updates_title',
    recent_updates_description: 'landing.recent_updates_description',
    schedule_demo: 'landing.schedule_demo',
    security_note: 'landing.security_note',
    automotive_description: 'landing.automotive_description',
    machinery_equipment_description: 'landing.machinery_equipment_description',
    media_communication_description: 'landing.media_communication_description',
    realtime_metrics_description: 'landing.realtime_metrics_description',
    advanced_semantic_search: 'landing.advanced_semantic_search',
    contextual_answers: 'landing.contextual_answers',
    intelligent_automation: 'landing.intelligent_automation',
    send: 'landing.send',
    flexible_ready: 'landing.flexible_ready',
    form_response_success: 'landing.form_response_success',
    form_response_title: 'landing.form_response_title',
    name_required: 'landing.name_required',
    email_required: 'landing.email_required',
    invalid_email: 'landing.invalid_email',
    required_field: 'landing.required_field',
    form_response_error: 'landing.form_response_error',
    api_documentation: 'landing.api_documentation',
    join_slack: 'landing.join_slack',
    platform: 'landing.platform',
    see_documentation: 'landing.see_documentation'
  },
  fileSearch: {
    graph: {
      noResults: 'fileSearch.graph.noResults',
      searchTextLoadScreen: 'fileSearch.graph.searchTextLoadScreen'
    },
    nodeMenu: {
      basicInfo: 'fileSearch.nodeMenu.basicInfo',
      totalFiles: 'fileSearch.nodeMenu.totalFiles',
      totalSize: 'fileSearch.nodeMenu.totalSize',
      category: 'fileSearch.nodeMenu.category',
      creationDate: 'fileSearch.nodeMenu.creationDate',
      visibility: 'fileSearch.nodeMenu.visibility',
      public: 'fileSearch.nodeMenu.public',
      private: 'fileSearch.nodeMenu.private',
      accessPermissions: 'fileSearch.nodeMenu.accessPermissions',
      extension: 'fileSearch.nodeMenu.extension',
      size: 'fileSearch.nodeMenu.size',
      processingStatus: 'fileSearch.nodeMenu.processingStatus'
    },
    loading: {
      message: 'fileSearch.loading.message'
    },
    sidebar: {
      fileSearch: 'fileSearch.sidebar.fileSearch'
    }
  },
  blog: {
    title: {
      whatsNew: 'blog.title.whatsNew'
    },
    section: {
      moreContent: 'blog.section.moreContent'
    },
    navigation: {
      back: 'blog.navigation.back',
      viewAllPosts: 'blog.navigation.viewAllPosts',
      backToBlog: 'blog.navigation.backToBlog'
    },
    search: {
      placeholder: 'blog.search.placeholder',
      resultsFor: 'blog.search.resultsFor',
      resultCount: {
        singular: 'blog.search.resultCount.singular',
        plural: 'blog.search.resultCount.plural'
      }
    },
    loading: {
      posts: 'blog.loading.posts',
      singlePost: 'blog.loading.singlePost'
    },
    error: {
      loadPosts: {
        title: 'blog.error.loadPosts.title',
        description: 'blog.error.loadPosts.description'
      }
    },
    empty: {
      noPosts: {
        title: 'blog.empty.noPosts.title',
        searchDescription: 'blog.empty.noPosts.searchDescription',
        generalDescription: 'blog.empty.noPosts.generalDescription'
      }
    },
    notFound: {
      title: 'blog.notFound.title',
      noSlug: 'blog.notFound.noSlug',
      description: 'blog.notFound.description'
    },
    post: {
      readingTime: {
        unit: 'blog.post.readingTime.unit',
        full: 'blog.post.readingTime.full'
      },
      author: {
        by: 'blog.post.author.by',
        unknown: 'blog.post.author.unknown'
      }
    },
    pagination: {
      previous: 'blog.pagination.previous',
      next: 'blog.pagination.next'
    },
    date: {
      notAvailable: 'blog.date.notAvailable',
      invalid: 'blog.date.invalid'
    },
    content: {
      titleNotAvailable: 'blog.content.titleNotAvailable',
      contentNotAvailable: 'blog.content.contentNotAvailable',
      defaultImageAlt: 'blog.content.defaultImageAlt'
    },
    external: {
      documentation: 'blog.external.documentation',
      apiStatus: 'blog.external.apiStatus'
    },
    accessibility: {
      backToBlog: 'blog.accessibility.backToBlog'
    }
  },
  notifications: {
    platform: {
      title: 'notifications.platform.title',
      empty: {
        title: 'notifications.platform.empty.title',
        description: 'notifications.platform.empty.description'
      }
    },
    releaseNotes: {
      title: 'notifications.releaseNotes.title',
      tooltip: 'notifications.releaseNotes.tooltip',
      empty: {
        title: 'notifications.releaseNotes.empty.title',
        description: 'notifications.releaseNotes.empty.description'
      }
    },
    common: {
      markAsRead: 'notifications.common.markAsRead',
      loading: 'notifications.common.loading',
      error: {
        fetch: 'notifications.common.error.fetch',
        markAsRead: 'notifications.common.error.markAsRead'
      },
      markAllAsRead: 'notifications.common.markAllAsRead'
    }
  },
  tickets: {
    page: {
      title: 'tickets.page.title',
      subtitle: 'tickets.page.subtitle'
    },
    create: {
      button: 'tickets.create.button',
      modal: {
        title: 'tickets.create.modal.title'
      },
      title_label: 'tickets.create.title_label',
      title_placeholder: 'tickets.create.title_placeholder',
      type_label: 'tickets.create.type_label',
      type_placeholder: 'tickets.create.type_placeholder',
      description_label: 'tickets.create.description_label',
      description_placeholder: 'tickets.create.description_placeholder',
      attachments_label: 'tickets.create.attachments_label',
      attachments_drag_text: 'tickets.create.attachments_drag_text',
      attachments_button: 'tickets.create.attachments_button',
      selected_files_label: 'tickets.create.selected_files_label',
      cancel_button: 'tickets.create.cancel_button',
      submit_button: 'tickets.create.submit_button',
      submitting_button: 'tickets.create.submitting_button',
      success_title: 'tickets.create.success_title',
      success_description: 'tickets.create.success_description',
      error_title: 'tickets.create.error_title',
      error_description: 'tickets.create.error_description'
    },
    search: {
      placeholder: 'tickets.search.placeholder'
    },
    filter: {
      status: {
        placeholder: 'tickets.filter.status.placeholder',
        all: 'tickets.filter.status.all',
        open: 'tickets.filter.status.open',
        in_progress: 'tickets.filter.status.in_progress',
        blocked: 'tickets.filter.status.blocked',
        resolved: 'tickets.filter.status.resolved'
      },
      type: {
        placeholder: 'tickets.filter.type.placeholder',
        all: 'tickets.filter.type.all',
        technical_problems: 'tickets.filter.type.technical_problems',
        integration_problems: 'tickets.filter.type.integration_problems',
        security_issues: 'tickets.filter.type.security_issues',
        suggestions: 'tickets.filter.type.suggestions',
        others: 'tickets.filter.type.others'
      }
    },
    error: {
      load_title: 'tickets.error.load_title',
      load_description: 'tickets.error.load_description'
    },
    empty: {
      title: 'tickets.empty.title',
      description: 'tickets.empty.description'
    },
    table: {
      title_column: 'tickets.table.title_column',
      type_column: 'tickets.table.type_column',
      created_date_column: 'tickets.table.created_date_column',
      deadline_column: 'tickets.table.deadline_column',
      status_column: 'tickets.table.status_column',
      actions_column: 'tickets.table.actions_column',
      deadline_undefined: 'tickets.table.deadline_undefined',
      deadline_not_estimated: 'tickets.table.deadline_not_estimated',
      no_results: 'tickets.table.no_results',
      chat_resolved_tooltip: 'tickets.table.chat_resolved_tooltip',
      chat_available_tooltip: 'tickets.table.chat_available_tooltip',
      evidence_resolved_tooltip: 'tickets.table.evidence_resolved_tooltip',
      evidence_button: 'tickets.table.evidence_button',
      close_resolved_tooltip: 'tickets.table.close_resolved_tooltip',
      close_button: 'tickets.table.close_button'
    },
    detail: {
      title_label: 'tickets.detail.title_label',
      deadline_label: 'tickets.detail.deadline_label',
      description_label: 'tickets.detail.description_label',
      attachments_label: 'tickets.detail.attachments_label',
      no_attachments: 'tickets.detail.no_attachments',
      created_at: 'tickets.detail.created_at',
      deadline_resolution: 'tickets.detail.deadline_resolution',
      type_label: 'tickets.detail.type_label',
      loading: 'tickets.detail.loading',
      error: 'tickets.detail.error'
    },
    chat: {
      title: 'tickets.chat.title',
      reference: 'tickets.chat.reference',
      empty_title: 'tickets.chat.empty_title',
      empty_subtitle: 'tickets.chat.empty_subtitle',
      input_placeholder: 'tickets.chat.input_placeholder',
      user_label: 'tickets.chat.user_label',
      support_label: 'tickets.chat.support_label',
      conversation_title: 'tickets.chat.conversation_title',
      conversation_subtitle: 'tickets.chat.conversation_subtitle',
      no_messages_title: 'tickets.chat.no_messages_title',
      no_messages_subtitle: 'tickets.chat.no_messages_subtitle',
      input_placeholder_detail: 'tickets.chat.input_placeholder_detail'
    },
    close: {
      dialog_title: 'tickets.close.dialog_title',
      dialog_description: 'tickets.close.dialog_description',
      dialog_confirm: 'tickets.close.dialog_confirm'
    },
    status: {
      open: 'tickets.status.open',
      in_progress: 'tickets.status.in_progress',
      blocked: 'tickets.status.blocked',
      resolved: 'tickets.status.resolved'
    },
    type: {
      technical_problems: 'tickets.type.technical_problems',
      integration_problems: 'tickets.type.integration_problems',
      security_issues: 'tickets.type.security_issues',
      suggestions: 'tickets.type.suggestions',
      others: 'tickets.type.others'
    }
  },
  assistant: {
    tools: {
      title: 'assistant.tools.title',
      extractions: {
        title: 'assistant.tools.extractions.title',
        description: {
          message: 'assistant.tools.extractions.description.message',
          label: 'assistant.tools.extractions.description.label',
          placeholder: 'assistant.tools.extractions.description.placeholder'
        },
        empty: {
          message: 'assistant.tools.extractions.empty.message',
          description: 'assistant.tools.extractions.empty.description'
        },
        add: 'assistant.tools.extractions.add',
        create: 'assistant.tools.extractions.create',
        edit: 'assistant.tools.extractions.edit',
        delete: {
          message: 'assistant.tools.extractions.delete.message',
          confirm: 'assistant.tools.extractions.delete.confirm',
          description: 'assistant.tools.extractions.delete.description'
        },
        name: {
          message: 'assistant.tools.extractions.name.message',
          placeholder: 'assistant.tools.extractions.name.placeholder'
        },
        fields: 'assistant.tools.extractions.fields',
        field: {
          name: {
            message: 'assistant.tools.extractions.field.name.message',
            placeholder: 'assistant.tools.extractions.field.name.placeholder'
          },
          description: {
            message: 'assistant.tools.extractions.field.description.message',
            placeholder: 'assistant.tools.extractions.field.description.placeholder'
          },
          examples: {
            message: 'assistant.tools.extractions.field.examples.message',
            placeholder: 'assistant.tools.extractions.field.examples.placeholder'
          },
          required: 'assistant.tools.extractions.field.required',
          add: 'assistant.tools.extractions.field.add',
          remove: 'assistant.tools.extractions.field.remove'
        },
        save: 'assistant.tools.extractions.save',
        cancel: 'assistant.tools.extractions.cancel',
        success: {
          created: 'assistant.tools.extractions.success.created',
          updated: 'assistant.tools.extractions.success.updated',
          deleted: 'assistant.tools.extractions.success.deleted'
        },
        error: {
          create: 'assistant.tools.extractions.error.create',
          update: 'assistant.tools.extractions.error.update',
          delete: 'assistant.tools.extractions.error.delete'
        },
        validation: {
          name: {
            required: 'assistant.tools.extractions.validation.name.required'
          },
          description: {
            required: 'assistant.tools.extractions.validation.description.required'
          },
          fields: {
            required: 'assistant.tools.extractions.validation.fields.required'
          },
          field: {
            name: {
              required: 'assistant.tools.extractions.validation.field.name.required'
            },
            description: {
              required: 'assistant.tools.extractions.validation.field.description.required'
            }
          }
        }
      }
    },
    collectedData: {
      title: 'assistant.collectedData.title',
      empty: {
        message: 'assistant.collectedData.empty.message',
        description: 'assistant.collectedData.empty.description'
      },
      export: 'assistant.collectedData.export',
      refresh: 'assistant.collectedData.refresh',
      filter: {
        extraction: 'assistant.collectedData.filter.extraction',
        date: 'assistant.collectedData.filter.date',
        chat: 'assistant.collectedData.filter.chat'
      },
      table: {
        date: 'assistant.collectedData.table.date',
        chat: 'assistant.collectedData.table.chat',
        extraction: 'assistant.collectedData.table.extraction',
        field: 'assistant.collectedData.table.field',
        value: 'assistant.collectedData.table.value'
      },
      loading: 'assistant.collectedData.loading',
      error: 'assistant.collectedData.error',
      perChat: 'assistant.collectedData.perChat',
      allData: 'assistant.collectedData.allData'
    },
    version: {
      tools: {
        warning: 'assistant.version.tools.warning'
      },
      deployed: 'assistant.version.deployed'
    },
    dashboard: {
      title: 'assistant.dashboard.title',
      collectedData: 'assistant.dashboard.collectedData',
      conversations: 'assistant.dashboard.conversations',
      conversationsDesc: 'assistant.dashboard.conversationsDesc',
      versions: 'assistant.dashboard.versions',
      versionsDesc: 'assistant.dashboard.versionsDesc',
      settings: 'assistant.dashboard.settings',
      noDeployedVersion: 'assistant.dashboard.noDeployedVersion',
      recentVersions: 'assistant.dashboard.recentVersions',
      activeConversations: 'assistant.dashboard.activeConversations',
      avgMessages: 'assistant.dashboard.avgMessages',
      satisfaction: 'assistant.dashboard.satisfaction',
      uniqueUsers: 'assistant.dashboard.uniqueUsers',
      metrics: {
        conversations: 'assistant.dashboard.metrics.conversations',
        conversations_tooltip: 'assistant.dashboard.metrics.conversations_tooltip',
        users: 'assistant.dashboard.metrics.users',
        users_tooltip: 'assistant.dashboard.metrics.users_tooltip',
        extractions: 'assistant.dashboard.metrics.extractions',
        extractions_tooltip: 'assistant.dashboard.metrics.extractions_tooltip',
        satisfaction: 'assistant.dashboard.metrics.satisfaction',
        satisfaction_tooltip: 'assistant.dashboard.metrics.satisfaction_tooltip',
        response_rate: 'assistant.dashboard.metrics.response_rate',
        response_rate_tooltip: 'assistant.dashboard.metrics.response_rate_tooltip'
      },
      health: {
        title: 'assistant.dashboard.health.title',
        subtitle: 'assistant.dashboard.health.subtitle',
        excellent: 'assistant.dashboard.health.excellent',
        attention: 'assistant.dashboard.health.attention',
        action: 'assistant.dashboard.health.action',
        response_rate_desc: 'assistant.dashboard.health.response_rate_desc',
        success_rate: 'assistant.dashboard.health.success_rate',
        success_rate_desc: 'assistant.dashboard.health.success_rate_desc',
        satisfaction_desc: 'assistant.dashboard.health.satisfaction_desc',
        availability: 'assistant.dashboard.health.availability',
        availability_desc: 'assistant.dashboard.health.availability_desc',
        status: 'assistant.dashboard.health.status',
        score: 'assistant.dashboard.health.score'
      },
      improvements: {
        high_impact: 'assistant.dashboard.improvements.high_impact',
        medium_impact: 'assistant.dashboard.improvements.medium_impact',
        low_impact: 'assistant.dashboard.improvements.low_impact',
        easy: 'assistant.dashboard.improvements.easy',
        medium: 'assistant.dashboard.improvements.medium',
        hard: 'assistant.dashboard.improvements.hard',
        progress: 'assistant.dashboard.improvements.progress',
        difficulty: 'assistant.dashboard.improvements.difficulty',
        improve_response_rate: 'assistant.dashboard.improvements.improve_response_rate',
        improve_response_rate_desc: 'assistant.dashboard.improvements.improve_response_rate_desc',
        analyze_failures: 'assistant.dashboard.improvements.analyze_failures',
        increase_accuracy: 'assistant.dashboard.improvements.increase_accuracy',
        increase_accuracy_desc: 'assistant.dashboard.improvements.increase_accuracy_desc',
        review_training: 'assistant.dashboard.improvements.review_training',
        improve_satisfaction: 'assistant.dashboard.improvements.improve_satisfaction',
        improve_satisfaction_desc: 'assistant.dashboard.improvements.improve_satisfaction_desc',
        collect_feedback: 'assistant.dashboard.improvements.collect_feedback',
        reduce_response_time: 'assistant.dashboard.improvements.reduce_response_time',
        reduce_response_time_desc: 'assistant.dashboard.improvements.reduce_response_time_desc',
        optimize_performance: 'assistant.dashboard.improvements.optimize_performance',
        increase_data_collection: 'assistant.dashboard.improvements.increase_data_collection',
        increase_data_collection_desc: 'assistant.dashboard.improvements.increase_data_collection_desc',
        create_extractions: 'assistant.dashboard.improvements.create_extractions',
        increase_engagement: 'assistant.dashboard.improvements.increase_engagement',
        increase_engagement_desc: 'assistant.dashboard.improvements.increase_engagement_desc',
        marketing_strategies: 'assistant.dashboard.improvements.marketing_strategies',
        title: 'assistant.dashboard.improvements.title',
        subtitle: 'assistant.dashboard.improvements.subtitle',
        all_perfect: 'assistant.dashboard.improvements.all_perfect',
        optimal_operation: 'assistant.dashboard.improvements.optimal_operation',
        excellent_performance: 'assistant.dashboard.improvements.excellent_performance',
        opportunities_identified: 'assistant.dashboard.improvements.opportunities_identified',
        prioritize_actions: 'assistant.dashboard.improvements.prioritize_actions',
        improvements: 'assistant.dashboard.improvements.improvements'
      },
      collected: {
        filtered: 'assistant.dashboard.collected.filtered',
        all: 'assistant.dashboard.collected.all',
        title: 'assistant.dashboard.collected.title',
        subtitle: 'assistant.dashboard.collected.subtitle',
        total: 'assistant.dashboard.collected.total',
        today: 'assistant.dashboard.collected.today',
        extractions: 'assistant.dashboard.collected.extractions',
        fields: 'assistant.dashboard.collected.fields',
        total_collected: 'assistant.dashboard.collected.total_collected',
        unique_fields: 'assistant.dashboard.collected.unique_fields',
        all_extractions: 'assistant.dashboard.collected.all_extractions',
        csv_filename_prefix: 'assistant.dashboard.collected.csv_filename_prefix',
        extraction_details: 'assistant.dashboard.collected.extraction_details',
        last_collection: 'assistant.dashboard.collected.last_collection'
      },
      peak: {
        title: 'assistant.dashboard.peak.title',
        subtitle: 'assistant.dashboard.peak.subtitle',
        peak_hour: 'assistant.dashboard.peak.peak_hour',
        conversations_at_time: 'assistant.dashboard.peak.conversations_at_time',
        peak_time_alert: 'assistant.dashboard.peak.peak_time_alert',
        busiest_day: 'assistant.dashboard.peak.busiest_day',
        total_analyzed: 'assistant.dashboard.peak.total_analyzed',
        conversations_last_days: 'assistant.dashboard.peak.conversations_last_days',
        heatmap_title: 'assistant.dashboard.peak.heatmap_title',
        less: 'assistant.dashboard.peak.less',
        more: 'assistant.dashboard.peak.more',
        busiest_hours: 'assistant.dashboard.peak.busiest_hours',
        conversations: 'assistant.dashboard.peak.conversations',
        sunday: 'assistant.dashboard.peak.sunday',
        monday: 'assistant.dashboard.peak.monday',
        tuesday: 'assistant.dashboard.peak.tuesday',
        wednesday: 'assistant.dashboard.peak.wednesday',
        thursday: 'assistant.dashboard.peak.thursday',
        friday: 'assistant.dashboard.peak.friday',
        saturday: 'assistant.dashboard.peak.saturday',
        insufficient_data: 'assistant.dashboard.peak.insufficient_data'
      },
      export: {
        conversations_report: 'assistant.dashboard.export.conversations_report',
        conversations_report_desc: 'assistant.dashboard.export.conversations_report_desc',
        collected_data: 'assistant.dashboard.export.collected_data',
        collected_data_desc: 'assistant.dashboard.export.collected_data_desc',
        export_now: 'assistant.dashboard.export.export_now',
        export_data: 'assistant.dashboard.export.export_data',
        export_reports: 'assistant.dashboard.export.export_reports',
        select_data: 'assistant.dashboard.export.select_data',
        cancel: 'assistant.dashboard.export.cancel',
        export: 'assistant.dashboard.export.export',
        automatic_reports: 'assistant.dashboard.export.automatic_reports',
        configure_automatic: 'assistant.dashboard.export.configure_automatic',
        configure_schedule: 'assistant.dashboard.export.configure_schedule',
        schedule_reports: 'assistant.dashboard.export.schedule_reports',
        schedule_description: 'assistant.dashboard.export.schedule_description',
        email_label: 'assistant.dashboard.export.email_label',
        email_placeholder: 'assistant.dashboard.export.email_placeholder',
        frequency: 'assistant.dashboard.export.frequency',
        daily: 'assistant.dashboard.export.daily',
        weekly: 'assistant.dashboard.export.weekly',
        monthly: 'assistant.dashboard.export.monthly',
        report_types: 'assistant.dashboard.export.report_types',
        active_schedules: 'assistant.dashboard.export.active_schedules',
        active: 'assistant.dashboard.export.active',
        next_delivery: 'assistant.dashboard.export.next_delivery',
        title: 'assistant.dashboard.export.title',
        subtitle: 'assistant.dashboard.export.subtitle',
        download_reports_desc: 'assistant.dashboard.export.download_reports_desc',
        no_schedules_yet: 'assistant.dashboard.export.no_schedules_yet',
        paused: 'assistant.dashboard.export.paused',
        performance_metrics: 'assistant.dashboard.export.performance_metrics',
        performance_metrics_desc: 'assistant.dashboard.export.performance_metrics_desc',
        executive_report: 'assistant.dashboard.export.executive_report',
        executive_report_desc: 'assistant.dashboard.export.executive_report_desc',
        daily_summary: 'assistant.dashboard.export.daily_summary',
        daily_summary_desc: 'assistant.dashboard.export.daily_summary_desc',
        weekly_report: 'assistant.dashboard.export.weekly_report',
        weekly_report_desc: 'assistant.dashboard.export.weekly_report_desc',
        monthly_insights: 'assistant.dashboard.export.monthly_insights',
        monthly_insights_desc: 'assistant.dashboard.export.monthly_insights_desc'
      },
      time: {
        minutes_suffix: 'assistant.dashboard.time.minutes_suffix'
      },
      time_filter: {
        all_data: 'assistant.dashboard.time_filter.all_data',
        last_hour: 'assistant.dashboard.time_filter.last_hour',
        last_2h: 'assistant.dashboard.time_filter.last_2h',
        last_6h: 'assistant.dashboard.time_filter.last_6h',
        last_12h: 'assistant.dashboard.time_filter.last_12h',
        last_24h: 'assistant.dashboard.time_filter.last_24h',
        today: 'assistant.dashboard.time_filter.today'
      },
      production: 'assistant.dashboard.production',
      preview: 'assistant.dashboard.preview',
      showData: 'assistant.dashboard.showData',
      hideData: 'assistant.dashboard.hideData',
      previewDataNotPersistent: 'assistant.dashboard.previewDataNotPersistent',
      configure: 'assistant.dashboard.configure',
      description: 'assistant.dashboard.description',
      whatsappAnalytics: 'assistant.dashboard.whatsappAnalytics',
      whatsappActivityEngagement: 'assistant.dashboard.whatsappActivityEngagement',
      activityLevel: 'assistant.dashboard.activityLevel',
      responseTime: 'assistant.dashboard.responseTime',
      totalMessages: 'assistant.dashboard.totalMessages',
      peakHours: 'assistant.dashboard.peakHours',
      conversation: {
        default_user: 'assistant.dashboard.conversation.default_user'
      },
      editAssistant: 'assistant.dashboard.editAssistant',
      excellent: 'assistant.dashboard.excellent',
      performance: 'assistant.dashboard.performance',
      performanceMetrics: 'assistant.dashboard.performanceMetrics',
      recentConversations: 'assistant.dashboard.recentConversations',
      good: 'assistant.dashboard.good',
      regular: 'assistant.dashboard.regular',
      activeChats: 'assistant.dashboard.activeChats',
      uniqueUsersCount: 'assistant.dashboard.uniqueUsersCount'
    },
    mention: {
      createExtraction: 'assistant.mention.createExtraction',
      addField: 'assistant.mention.addField',
      fieldExample: 'assistant.mention.fieldExample'
    },
    extraction: {
      tooltip: 'assistant.extraction.tooltip',
      update_temporary: 'assistant.extraction.update_temporary',
      update_temporary_description: 'assistant.extraction.update_temporary_description',
      create_temporary: 'assistant.extraction.create_temporary',
      create_temporary_description: 'assistant.extraction.create_temporary_description',
      unsaved_badge: 'assistant.extraction.unsaved_badge',
      inserted: 'assistant.extraction.inserted',
      inserted_description: 'assistant.extraction.inserted_description',
      field_placeholder: 'assistant.extraction.field_placeholder',
      field_description: 'assistant.extraction.field_description',
      steps: {
        name: 'assistant.extraction.steps.name',
        examples: 'assistant.extraction.steps.examples',
        description: 'assistant.extraction.steps.description'
      },
      update_button: 'assistant.extraction.update_button',
      press_enter_continue: 'assistant.extraction.press_enter_continue',
      default_field_name: 'assistant.extraction.default_field_name',
      add_description_optional: 'assistant.extraction.add_description_optional'
    },
    createAssistantSuccess: {
      title: 'assistant.createAssistantSuccess.title',
      description: 'assistant.createAssistantSuccess.description'
    },
    createAssistantError: {
      title: 'assistant.createAssistantError.title',
      description: 'assistant.createAssistantError.description'
    },
    deleteAssistantSuccess: {
      title: 'assistant.deleteAssistantSuccess.title',
      description: 'assistant.deleteAssistantSuccess.description'
    },
    deleteAssistantError: {
      title: 'assistant.deleteAssistantError.title',
      description: 'assistant.deleteAssistantError.description'
    },
    createVersionSuccess: {
      title: 'assistant.createVersionSuccess.title',
      description: 'assistant.createVersionSuccess.description'
    },
    createVersionError: {
      title: 'assistant.createVersionError.title',
      description: 'assistant.createVersionError.description'
    },
    deployVersionSuccess: {
      title: 'assistant.deployVersionSuccess.title',
      description: 'assistant.deployVersionSuccess.description'
    },
    deployVersionError: {
      title: 'assistant.deployVersionError.title',
      description: 'assistant.deployVersionError.description'
    },
    deleteVersionSuccess: {
      title: 'assistant.deleteVersionSuccess.title',
      description: 'assistant.deleteVersionSuccess.description'
    },
    deleteVersionError: {
      title: 'assistant.deleteVersionError.title',
      description: 'assistant.deleteVersionError.description'
    },
    conversations: {
      title: 'assistant.conversations.title',
      description: 'assistant.conversations.description',
      viewAll: 'assistant.conversations.viewAll',
      backToDashboard: 'assistant.conversations.backToDashboard',
      noResults: 'assistant.conversations.noResults',
      viewDetails: 'assistant.conversations.viewDetails',
      viewConversation: 'assistant.conversations.viewConversation',
      export: 'assistant.conversations.export',
      hiddenContent: 'assistant.conversations.hiddenContent',
      hideSensitiveData: 'assistant.conversations.hideSensitiveData',
      showSensitiveData: 'assistant.conversations.showSensitiveData',
      hideData: 'assistant.conversations.hideData',
      showData: 'assistant.conversations.showData',
      columns: {
        question: 'assistant.conversations.columns.question',
        response: 'assistant.conversations.columns.response',
        user: 'assistant.conversations.columns.user',
        email: 'assistant.conversations.columns.email',
        date: 'assistant.conversations.columns.date',
        extractions: 'assistant.conversations.columns.extractions',
        actions: 'assistant.conversations.columns.actions',
        source: 'assistant.conversations.columns.source'
      },
      filters: {
        searchPlaceholder: 'assistant.conversations.filters.searchPlaceholder',
        startDate: 'assistant.conversations.filters.startDate',
        endDate: 'assistant.conversations.filters.endDate',
        dateRange: 'assistant.conversations.filters.dateRange',
        extractionType: 'assistant.conversations.filters.extractionType',
        allExtractions: 'assistant.conversations.filters.allExtractions',
        emailPlaceholder: 'assistant.conversations.filters.emailPlaceholder',
        source: 'assistant.conversations.filters.source',
        allSources: 'assistant.conversations.filters.allSources',
        production: 'assistant.conversations.filters.production',
        preview: 'assistant.conversations.filters.preview',
        clear: 'assistant.conversations.filters.clear'
      },
      pagination: {
        showing: 'assistant.conversations.pagination.showing',
        rowsPerPage: 'assistant.conversations.pagination.rowsPerPage',
        page: 'assistant.conversations.pagination.page',
        firstPage: 'assistant.conversations.pagination.firstPage',
        previousPage: 'assistant.conversations.pagination.previousPage',
        nextPage: 'assistant.conversations.pagination.nextPage',
        lastPage: 'assistant.conversations.pagination.lastPage'
      },
      detail: {
        title: 'assistant.conversations.detail.title',
        messagesTab: 'assistant.conversations.detail.messagesTab',
        extractionsTab: 'assistant.conversations.detail.extractionsTab',
        extractionsCount: 'assistant.conversations.detail.extractionsCount',
        noExtractions: 'assistant.conversations.detail.noExtractions',
        userLabel: 'assistant.conversations.detail.userLabel',
        assistantLabel: 'assistant.conversations.detail.assistantLabel',
        extractionLabel: 'assistant.conversations.detail.extractionLabel',
        fieldsLabel: 'assistant.conversations.detail.fieldsLabel',
        confidence: 'assistant.conversations.detail.confidence'
      },
      export_csv: {
        date: 'assistant.conversations.export_csv.date',
        user: 'assistant.conversations.export_csv.user',
        email: 'assistant.conversations.export_csv.email',
        question: 'assistant.conversations.export_csv.question',
        response: 'assistant.conversations.export_csv.response',
        extractions: 'assistant.conversations.export_csv.extractions',
        answered: 'assistant.conversations.export_csv.answered',
        conversationId: 'assistant.conversations.export_csv.conversationId'
      }
    }
  },
  file_table_input: {
    dialog: {
      title: 'file_table_input.dialog.title'
    },
    files: {
      label: 'file_table_input.files.label'
    },
    drag_drop: {
      main_text: 'file_table_input.drag_drop.main_text',
      supported_formats: 'file_table_input.drag_drop.supported_formats',
      max_size: 'file_table_input.drag_drop.max_size',
      max_size_translation: 'file_table_input.drag_drop.max_size_translation',
    },
    file_too_large_inline: 'file_table_input.file_too_large_inline',
    selected_files: {
      label: 'file_table_input.selected_files.label'
    },
    youtube: {
      label: 'file_table_input.youtube.label',
      warning: 'file_table_input.youtube.warning',
      url_placeholder: 'file_table_input.youtube.url_placeholder',
      name_placeholder: 'file_table_input.youtube.name_placeholder',
      add_button: 'file_table_input.youtube.add_button',
      added_links: {
        label: 'file_table_input.youtube.added_links.label'
      }
    },
    buttons: {
      cancel: 'file_table_input.buttons.cancel',
      upload: 'file_table_input.buttons.upload',
      uploading: 'file_table_input.buttons.uploading'
    },
    toast: {
      cannot_upload: {
        title: 'file_table_input.toast.cannot_upload.title',
        description: 'file_table_input.toast.cannot_upload.description'
      },
      file_too_large: {
        title: 'file_table_input.toast.file_too_large.title',
        description: 'file_table_input.toast.file_too_large.description'
      },
      invalid_url: {
        title: 'file_table_input.toast.invalid_url.title',
        description: 'file_table_input.toast.invalid_url.description'
      },
      invalid_video_id: {
        title: 'file_table_input.toast.invalid_video_id.title',
        description: 'file_table_input.toast.invalid_video_id.description'
      },
      duplicate_video: {
        title: 'file_table_input.toast.duplicate_video.title',
        description: 'file_table_input.toast.duplicate_video.description'
      },
      no_content: {
        title: 'file_table_input.toast.no_content.title',
        description: 'file_table_input.toast.no_content.description'
      },
      no_folder: {
        title: 'file_table_input.toast.no_folder.title',
        description: 'file_table_input.toast.no_folder.description'
      },
      upload_failed: {
        title: 'file_table_input.toast.upload_failed.title',
        description: 'file_table_input.toast.upload_failed.description'
      },
      upload_success: {
        title: 'file_table_input.toast.upload_success.title',
        description: 'file_table_input.toast.upload_success.description'
      }
    }
  },
  translation: {
    fileManage: {
      title: 'translation.fileManage.title',
      description: 'translation.fileManage.description',
      searchPlaceholder: 'translation.fileManage.searchPlaceholder',
      uploadInput: {
        sendFileForTranslation: 'translation.fileManage.uploadInput.sendFileForTranslation',
        sendTemplate: 'translation.fileManage.uploadInput.sendTemplate',
        templateFormattingInstructionOne: 'translation.fileManage.uploadInput.templateFormattingInstructionOne',
        templateFormattingInstructionTwo: 'translation.fileManage.uploadInput.templateFormattingInstructionTwo',
        templateFormattingExampleLabel: 'translation.fileManage.uploadInput.templateFormattingExampleLabel',
        templateFormattingExampleValue: 'translation.fileManage.uploadInput.templateFormattingExampleValue',
        templateFormattingCopyButton: 'translation.fileManage.uploadInput.templateFormattingCopyButton',
        templateFormattingCopiedShort: 'translation.fileManage.uploadInput.templateFormattingCopiedShort',
        templateFormattingCopiedTitle: 'translation.fileManage.uploadInput.templateFormattingCopiedTitle',
        templateFormattingCopiedDescription: 'translation.fileManage.uploadInput.templateFormattingCopiedDescription',
        templateFormattingCopyFailedTitle: 'translation.fileManage.uploadInput.templateFormattingCopyFailedTitle',
        templateFormattingCopyFailedDescription: 'translation.fileManage.uploadInput.templateFormattingCopyFailedDescription'
      },
      deleteDialog: {
        deleteFileTitle: 'translation.fileManage.deleteDialog.deleteFileTitle',
        deleteFilesTitle: 'translation.fileManage.deleteDialog.deleteFilesTitle',
        deleteFileDescription: 'translation.fileManage.deleteDialog.deleteFileDescription',
        deleteFilesDescription: 'translation.fileManage.deleteDialog.deleteFilesDescription'
      },
      table: {
        selectAllFiles: 'translation.fileManage.table.selectAllFiles',
        selectRow: 'translation.fileManage.table.selectRow',
        noFilesFound: 'translation.fileManage.table.noFilesFound',
        loadingFiles: 'translation.fileManage.table.loadingFiles',
        previousPage: 'translation.fileManage.table.previousPage',
        nextPage: 'translation.fileManage.table.nextPage'
      },
      tabs: {
        filesForTranslation: 'translation.fileManage.tabs.filesForTranslation',
        templates: 'translation.fileManage.tabs.templates'
      }
    },
    glossary: {
      title: 'translation.glossary.title',
      description: 'translation.glossary.description',
      deleteDialog: {
        deleteGlossariesTitle: 'translation.glossary.deleteDialog.deleteGlossariesTitle',
        deleteGlossariesDescription: 'translation.glossary.deleteDialog.deleteGlossariesDescription'
      },
      table: {
        selectAllGlossaries: 'translation.glossary.table.selectAllGlossaries',
        selectRow: 'translation.glossary.table.selectRow',
        name: 'translation.glossary.table.name',
        noGlossariesFound: 'translation.glossary.table.noGlossariesFound',
        loadingGlossaries: 'translation.glossary.table.loadingGlossaries'
      },
      toolbar: {
        createButton: 'translation.glossary.toolbar.createButton'
      }
    },
    translation: {
      title: 'translation.translation.title',
      description: 'translation.translation.description',
      createDialog: {
        reviewBeforeFinish: 'translation.translation.createDialog.reviewBeforeFinish',
        autoSplit: 'translation.translation.createDialog.autoSplit',
        autoSplitTooltip: 'translation.translation.createDialog.autoSplitTooltip',
        extractTables: 'translation.translation.createDialog.extractTables',
        start: 'translation.translation.createDialog.start'
      },
      pdfViewer: {
        errorLoading: 'translation.translation.pdfViewer.errorLoading',
        zoomIn: 'translation.translation.pdfViewer.zoomIn',
        zoomOut: 'translation.translation.pdfViewer.zoomOut'
      },
      reviewDialog: {
        couldNotLoadData: 'translation.translation.reviewDialog.couldNotLoadData',
        singleEdit: 'translation.translation.reviewDialog.singleEdit',
        multipleEdits: 'translation.translation.reviewDialog.multipleEdits',
        title: 'translation.translation.reviewDialog.title',
        confirmTranslation: 'translation.translation.reviewDialog.confirmTranslation',
        sendFeedback: 'translation.translation.reviewDialog.sendFeedback',
        applyChanges: 'translation.translation.reviewDialog.applyChanges',
        applyingChanges: 'translation.translation.reviewDialog.applyingChanges',
        waitApplyingChanges: 'translation.translation.reviewDialog.waitApplyingChanges',
        preparingSingleFile: 'translation.translation.reviewDialog.preparingSingleFile',
        preparingMultipleFiles: 'translation.translation.reviewDialog.preparingMultipleFiles',
        documentOfTotal: 'translation.translation.reviewDialog.documentOfTotal',
        reprocess: 'translation.translation.reviewDialog.reprocess'
      },
      reviewPanel: {
        originalLabel: 'translation.translation.reviewPanel.originalLabel',
        translatedLabel: 'translation.translation.reviewPanel.translatedLabel',
        tooltipRotatePdf: 'translation.translation.reviewPanel.tooltipRotatePdf',
        tooltipZoomIn: 'translation.translation.reviewPanel.tooltipZoomIn',
        tooltipZoomOut: 'translation.translation.reviewPanel.tooltipZoomOut',
        tooltipZoomReset: 'translation.translation.reviewPanel.tooltipZoomReset'
      },
      feedbackDialog: {
        title: 'translation.translation.feedbackDialog.title',
        descriptionPlaceholder: 'translation.translation.feedbackDialog.descriptionPlaceholder',
        selectImage: 'translation.translation.feedbackDialog.selectImage',
        filesHint: 'translation.translation.feedbackDialog.filesHint',
        cancel: 'translation.translation.feedbackDialog.cancel',
        submit: 'translation.translation.feedbackDialog.submit',
        toast: {
          successTitle: 'translation.translation.feedbackDialog.toast.successTitle',
          errorTitle: 'translation.translation.feedbackDialog.toast.errorTitle',
          errorDescription: 'translation.translation.feedbackDialog.toast.errorDescription'
        },
        validation: {
          descriptionMin: 'translation.translation.feedbackDialog.validation.descriptionMin',
          descriptionMax: 'translation.translation.feedbackDialog.validation.descriptionMax',
          maxFiles: 'translation.translation.feedbackDialog.validation.maxFiles',
          onlyImages: 'translation.translation.feedbackDialog.validation.onlyImages',
          maxFileSize: 'translation.translation.feedbackDialog.validation.maxFileSize'
        }
      },
      selectGlossary: {
        noGlossariesFound: 'translation.translation.selectGlossary.noGlossariesFound',
        placeholder: 'translation.translation.selectGlossary.placeholder',
        searchPlaceholder: 'translation.translation.selectGlossary.searchPlaceholder'
      },
      selectTemplateFile: {
        noFilesFound: 'translation.translation.selectTemplateFile.noFilesFound',
        placeholder: 'translation.translation.selectTemplateFile.placeholder'
      },
      selectTranslationFile: {
        noFilesFound: 'translation.translation.selectTranslationFile.noFilesFound',
        placeholder: 'translation.translation.selectTranslationFile.placeholder'
      },
      historyTable: {
        status: {
          complete: 'translation.translation.historyTable.status.complete',
          pending: 'translation.translation.historyTable.status.pending',
          running: 'translation.translation.historyTable.status.running',
          review: 'translation.translation.historyTable.status.review',
          error: 'translation.translation.historyTable.status.error',
          quotaExceeded: 'translation.translation.historyTable.status.quotaExceeded'
        },
        createdBy: 'translation.translation.historyTable.createdBy',
        openReview: 'translation.translation.historyTable.openReview',
        reprocess: 'translation.translation.historyTable.reprocess',
        noTranslationsFound: 'translation.translation.historyTable.noTranslationsFound',
        loadingTranslations: 'translation.translation.historyTable.loadingTranslations'
      },
      reprocess: {
        toast: {
          startedTitle: 'translation.translation.reprocess.toast.startedTitle',
          startedDescription: 'translation.translation.reprocess.toast.startedDescription',
          alreadyRunningTitle: 'translation.translation.reprocess.toast.alreadyRunningTitle',
          alreadyRunningDescription: 'translation.translation.reprocess.toast.alreadyRunningDescription',
          errorTitle: 'translation.translation.reprocess.toast.errorTitle',
          errorDescription: 'translation.translation.reprocess.toast.errorDescription'
        }
      },
      historyToolbar: {
        searchPlaceholder: 'translation.translation.historyToolbar.searchPlaceholder'
      },
      completeDialog: {
        title: 'translation.translation.completeDialog.title',
        couldNotLoadData: 'translation.translation.completeDialog.couldNotLoadData',
        originalFile: 'translation.translation.completeDialog.originalFile',
        translatedFiles: 'translation.translation.completeDialog.translatedFiles',
        translatedFile: 'translation.translation.completeDialog.translatedFile',
        downloadAll: 'translation.translation.completeDialog.downloadAll',
        downloadError: {
          title: 'translation.translation.completeDialog.downloadError.title',
          description: 'translation.translation.completeDialog.downloadError.description'
        },
        reprocess: 'translation.translation.completeDialog.reprocess'
      }
    }
  }
};
